import { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../Axios";
import { Urls } from "../../Urls";
import Select from "react-select/creatable";
import "./Indent.css";
import ViewEnquiry from "../Chat/chat";
import { toast } from "react-toastify";
import { currentRequestTimeStamp, isMobile, Activity } from "../../Constants";
import classes from "../TrucksAvailable/TrucksAvailable.module.css";
import Modal from "../Shared/PopupModal/PopupModal";
import { mailerAPI, next_page } from "../Freightrates1/Utility";
import Pagination from "react-js-pagination";
import AddIndent from "./AddIndent";
import classes1 from "./Indent.module.css";
import ReactTooltip from "react-tooltip";
import EditIndents from "./EditIndents/EditIndents";
import PrivateMarketplace from "./PrivateMarketplace/PrivateMarketplace";
import Popupwidget from "../Shared/PopupModal/PopupModal"
import MultiSelectFilterUI from "../Shared/newfilterui/MultiSelectFilterUI";
import TransportType from "./Transporttype";
import ExpiryCountdown from "./ExpiryCountdown";
import {
  checkModuleAccess,
  titleCase,
} from "../../Utility";
import Loader from "../Loader/Loader";
import { DownloadIndentReports } from "./DownloadReport/IndentReport";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import StatusBadge from "./components/StatusBadge";
import AllocationCard from "./components/AllocationCard";
import { getProfileDetails } from "../CompanyProfileNew/Utility";
import NewPrivateMarketPlace from "./PrivateMarketplace/NewPrivateMarketPlace";
import { EditableEmailsContext } from "../../Context/EditableEmailsContext";
import BulkUploadFile from "./BulkUploadFile";
import { useIndentTracking } from "./hooks/useIndentTracking";
import ViewLsp from "./components/ViewLsp";
import ViewIndentSummary from "./ViewIndentSummary/ViewIndentSummary";
import useViewOnlyAccess from "../../hooks/useViewOnlyAccess";
import { MastersChangeLog } from "../CompanyProfileNew/Utility";

const Indent = ({
  setOpenMenuId,
  policy,
  filtered_details,
  setfiltered_details = "",
  list_created,
  setlist_created,
  list_origins,
  list_user,
  setlist_user,
  setlist_origins,
  list_destinations,
  setlist_destinations,
  list_trucks,
  setlist_trucks,
  list_placement,
  setlist_placement,
  rspl = [],
  planningbutton = false,
  all_indent_list = [],
  update_orders = "",
  selected_date,
  item,
}) => {

  const { isRestricted, canAccessReports, noAccess: noIndentaccess } = useViewOnlyAccess("indent", "lorri_indent_request", true);

  var mindate = new Date();
  var day = ("0" + mindate.getDate()).slice(-2);
  var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
  var year = mindate.getFullYear();
  var todaydate =
    year.toString() + "-" + month.toString() + "-" + day.toString() + "";

  const [origin, setorigin] = useState({});
  const [inputorigin, setinputorigin] = useState("");
  const [destination, setdestination] = useState({});
  const [inputdestination, setinputdestination] = useState("");
  const [selectedTrucks, setselectedTrucks] = useState([]);
  const [TruckTypes, setTruckTypes] = useState([]);
  const [truckrequired, settruckrequired] = useState();
  const [cancelledindents, setCancelledindents] = useState(false);
  const [expiredIndents, setExpiredIndents] = useState(false);
  const [pendingIndents, setPendingIndents] = useState(false);
  const [acceptedIndents, setAcceptedIndents] = useState(false);
  const [rejectedIndents, setRejectedIndents] = useState(false);
  const [date, setduedate] = useState(todaydate);
  const [send_data, setsend_data] = useState([]);
  const [isPrivateMarketAuto, setIsPrivateMarketAuto] = useState(false);
  const [step, setStep] = useState(0);
  const [file, setFile] = useState("");
  const [newStep, setNewStep] = useState(1);
  const [finalKeys, setFinalKeys] = useState();
  const [data, setData] = useState();
  const [totalRequiredFields, setTotalRequiredFields] = useState();
  const [floatFromFM, setFloatFromFM] = useState("yes");
  const [dopStartTime, setDopStartTime] = useState("");
  const [dopEndTime, setDopEndTime] = useState("");

  const [emailTemplate, setemailTemplate] = useState({
    acceptanceFromCompany: "",
    acceptanceCCCompany: [],
    acceptanceContentCompany: "",
    acceptanceSubjectCompany: "",
    acceptanceFromTransporter: "",
    acceptanceCCTransporter: [],
    acceptanceContentTransporter: "",
    acceptanceSubjectTransporter: "",
    updateFromCompany: "",
    updateCCCompany: [],
    updateContentCompany: "",
    updateSubjectCompany: "",
    updateFromTransporter: "",
    updateCCTransporter: [],
    updateContentTransporter: "",
    updateSubjectTransporter: "",
    cancelFromCompany: "",
    cancelCCCompany: [],
    cancelContentCompany: "",
    cancelSubjectCompany: "",
    cancelFromTransporter: "",
    cancelCCTransporter: [],
    cancelContentTransporter: "",
    cancelSubjectTransporter: "",
    allocateFromCompany: "",
    allocateCCCompany: [],
    allocateContentCompany: "",
    allocateSubjectCompany: "",
    allocateFromTransporter: "",
    allocateCCTransporter: [],
    allocateContentTransporter: "",
    allocateSubjectTransporter: "",
    privateFromCompany: "",
    privateCCCompany: [],
    privateContentCompany: "",
    privateSubjectCompany: "",
    privateFromTransporter: "",
    privateCCTransporter: [],
    privateContentTransporter: "",
    privateSubjectTransporter: "",
  });
  // const [all_data, setall_data] = useState([])
  // const [display, setdisplay] = useState(false)
  const [show, setshow] = useState(false);
  const [useroption, setUseroption] = useState([]);

  const { trackIndentEvent } = useIndentTracking()

  var company_mail = localStorage.getItem("useremail");

  const [skipactive, setSkipactive] = useState(0);

  // for filters
  const [filter, setFilter] = useState(false);
  const [totalindents, setTotalindents] = useState(0);
  const [allowed_view_indent, setallowed_view_indent] = useState(false);
  const [userview, setuserview] = useState(true);
  // const history = useHistory();
  const [indentBucket, setIndentBucket] = useState("active");
  const [indentLevel, setIndentLevel] = useState("user_view");
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterPayload, setFilterPayload] = useState(null);
  const [showNewFilter, setShowNewFilter] = useState(false);
  const { companyProfile } = useContext(UserApiContext);
  const companyId = companyProfile?.domain_data?.company_id;
  const { userDetails } = useContext(UserApiContext);
  const [autoView, setAutoView] = useState(true);

  const emailData = useContext(EditableEmailsContext);
  const user_id = userDetails?.user_id;
  const user_email = userDetails?.email;

  const formatTime = (t) => {
    if (!t) return "";
    const s = String(t);
    return s.length >= 5 ? s.slice(0, 5) : s;
  };

  const change_activity = (item) => ([
    {
      lane_name: `${item.routes?.[0]?.origin?.location?.location} to ${item.routes
        ?.map(route => route.destination?.location?.location)
        .join(" to ")
        }`,
      load_id: item.load_id,
      Trucktype: item.suggested_truck?.map((truck) => truck.truck_type).join(", "),

    }
  ]);

  //useeffect to run on first time rendering and when dependency changes
  useEffect(() => {
    if (setOpenMenuId) {
      setOpenMenuId(null)
    }
    // Set the state to show loader initially
    setshow(true);

    // Check if companyProfile and userDetails are available
    if (companyProfile && userDetails) {
      // Ensure companyProfile contains domain_data and company_id
      if (companyProfile.domain_data && companyProfile.domain_data.company_id) {
        var id = companyProfile.domain_data.company_id;

        // Fetch profile details for the given company_id and indent type
        getProfileDetails(id, "indent", "company")
          .then((res) => {
            if (res.data && res.data.length > 0) {
              if (res.data[0] && res.data[0].indent) {
                // Update auto view state based on auto_allocation value
                setAutoView(
                  res.data[0].indent.auto_allocation === "yes" ? true : false
                );

                // Update private market auto state based on auto_market_place_enable value
                if (res.data[0].indent.auto_market_place_enable === "yes") {
                  setIsPrivateMarketAuto(true);
                }
              }
            }
          })
          .catch((err) => {
            // Hide loader and log error if there's an issue fetching profile details
            setshow(false);
            console.log(err);
          });
      }

      // Set the document title for the page
      document.title = "LoRRI - Indent Request";

      // Check if planning button is true
      if (planningbutton) {
        if (rspl[0]) {
          var master_data = [];

          // Check if rspl contains allocated trucks
          if (
            rspl.length > 0 &&
            rspl[0].item &&
            rspl[0].item.allocated_truck &&
            rspl[0].item.allocated_truck.length > 0
          ) {
            rspl[0].item.allocated_truck.map((trucks) => {
              return axios
                .post(`${Urls.freight_transporter}?module=indents`, {
                  lanes: [
                    {
                      origin: rspl[0].item.routes[0].origin,
                      destination:
                        rspl[0].item.routes[rspl[0].item.routes.length - 1]
                          .destination,
                      truck_type: {
                        label: trucks.truck_type,
                        value: trucks.truck_type,
                      },
                    },
                  ],
                })
                .then((res) => {
                  if (res.data) {
                    var temp = res.data.transporter_list[0]
                      ? res.data.transporter_list[0].transporter_details
                      : [];
                    var list = [];
                    temp.map((item) => {
                      list.push(item.transporter);
                      return item;
                    });
                    // setshow(false)
                    axios
                      .post(`${Urls.freight_master}?action=check_lane`, {
                        lanes: [
                          {
                            origin: rspl[0].item.routes[0].origin,
                            destination:
                              rspl[0].item.routes[
                                rspl[0].item.routes.length - 1
                              ].destination,
                            truck_type: {
                              label: trucks.truck_type,
                              value: trucks.truck_type,
                            },
                            route_code: rspl[0].item.route_code,
                          },
                        ],
                      })
                      .then((res) => {
                        // If lane exists, add data to master_data
                        setshow(true);
                        if (
                          res.data.exists &&
                          res.data.exists.exists === "yes"
                        ) {
                          master_data.push({
                            origin: rspl[0].item.routes[0].origin,
                            destination:
                              rspl[0].item.routes[
                                rspl[0].item.routes.length - 1
                              ].destination,
                            lane: `${rspl[0].item.routes[0].origin.location_name
                              }-${rspl[0].item.routes[
                                rspl[0].item.routes.length - 1
                              ].destination.location_name
                              }-${rspl[0].item.dispatch_date}`,
                            truck_types: [
                              {
                                label: trucks.truck_type,
                                value: trucks.truck_type,
                                truck_max_volume: trucks.truck_max_volume,
                                truck_max_weight: trucks.truck_max_weight,
                              },
                            ],
                            truck_required: 1,
                            placement_date: rspl[0].item.dispatch_date,
                            from: "planning",
                            plan_type: rspl[0].item.plan_type,
                            truck_id: trucks.truck_id,
                            load_id: rspl[0].item.load_id,
                            freightid: res.data.exists.freight_id,
                            shortlisted_transporters:
                              trucks.transporter_list.map((transporter) => {
                                transporter.is_shortlist = true;
                                transporter.selected = true;
                                transporter.transporter_name =
                                  transporter.transporter.transporter_name;
                                transporter.transporter_id =
                                  transporter.transporter.transporter_id;
                                return transporter;
                              }),
                            email: localStorage.getItem("useremail"),
                            assigned_to: localStorage.getItem("useremail"),
                            assigned_by: localStorage.getItem("useremail"),
                          });
                        }
                        // Update state with master data
                        setsend_data(master_data);
                      })
                      .catch((err) => {
                        // Log error and hide loader if there's an issue checking lane
                        console.log(err);
                        setshow(false);
                      });
                  }
                })
                .catch((err) => {
                  // Log error and hide loader if there's an issue fetching transporter details
                  console.log(err);
                  setshow(false);
                })
                .finally(() => {
                  setshow(false);
                });
            });
          }
        } else {
          master_data = [];
          // Process all indent orders if planning button is false
          if (
            all_indent_list[0] &&
            all_indent_list[0].indent_orders &&
            all_indent_list[0].indent_orders.length > 0
          ) {
            all_indent_list[0].indent_orders.map((all_list, index) => {
              if (
                all_list.allocated_truck &&
                all_list.allocated_truck &&
                (!all_list.enquiry_floated || all_list.enquiry_floated !== true)
              ) {
                const promises = all_list.allocated_truck.map(
                  (trucks, index) => {
                    var payload = [
                      {
                        origin: all_list.routes[0].origin,
                        destination:
                          all_list.routes[all_list.routes.length - 1]
                            .destination,
                        truck_type: {
                          label: trucks.truck_type,
                          value: trucks.truck_type,
                        },
                        route_code: all_list.route_code,
                      },
                    ];
                    return axios
                      .post(`${Urls.freight_master}?action=check_lane`, {
                        lanes: payload,
                      })
                      .then((res) => {
                        setshow(true);
                        if (
                          res.data.exists &&
                          res.data.exists.exists === "yes"
                        ) {
                          var planning_origin = all_list.routes[0].origin;
                          var planning_destination =
                            all_list.routes[all_list.routes.length - 1]
                              .destination;
                          var data = {
                            origin: planning_origin,
                            destination: planning_destination,
                            truck_types: [
                              {
                                label: trucks.truck_type,
                                value: trucks.truck_type,
                                truck_max_volume: trucks.truck_max_volume,
                                truck_max_weight: trucks.truck_max_weight,
                              },
                            ],
                            truck_required: 1,
                            lane: `${all_list.routes[0].origin.location_name}-${all_list.routes[all_list.routes.length - 1]
                              .destination.location_name
                              }-${all_list.dispatch_date}`,
                            load_id: all_list.load_id,
                            from: "planning",
                            truck_id: trucks.truck_id,
                            plan_type: all_list.plan_type,
                            placement_date: all_list.dispatch_date,
                            freightid: res.data.exists.freight_id,
                            sales_invoice_ids: trucks.invoice_list.map(
                              (inv) => {
                                return inv?.invoice_id;
                              }
                            ),
                            shortlisted_transporters:
                              trucks.transporter_list.map((transporter) => {
                                transporter.is_shortlist = true;
                                transporter.selected = true;
                                transporter.transporter_name =
                                  transporter.transporter.transporter_name;
                                transporter.transporter_id =
                                  transporter.transporter.transporter_id;
                                return transporter;
                              }),
                            email: localStorage.getItem("useremail"),
                            assigned_to: localStorage.getItem("useremail"),
                            assigned_by: localStorage.getItem("useremail"),
                          };
                          master_data.push(data);
                          return data;
                        }
                      })
                      .catch((error) => {
                        // Log error and hide loader if there's an issue checking lane
                        console.log(error);
                        setshow(false);
                        return null;
                      })
                      .finally(() => {
                        setshow(false);
                      });
                  }
                );
                // Resolve all promises and update state with results
                Promise.all(promises)
                  .then((masterDataResults) => {
                    masterDataResults = masterDataResults.filter(
                      (result) => result !== null
                    );
                    setsend_data((prevData) => [
                      ...prevData,
                      ...masterDataResults,
                    ]);
                  })
                  .catch((error) => {
                    // Log error and hide loader if there's an issue with promises
                    console.log(error);
                    setshow(false);
                  });
              }
            });
          }
        }

        // Fetch user data for setting user options
        axios
          .get(
            `${Urls.user_data}?field=all_users&email=${localStorage.getItem(
              "useremail"
            )}`
          )
          .then((res) => {
            if (res.data && res.data.length > 0) {
              setUseroption(res.data);
            }
          })
          .catch((err) => {
            // Log error and hide loader if there's an issue fetching user data
            console.log(err);
            setshow(false);
          });
      }

      // If planning button is not true
      if (!planningbutton) {
        // Apply filter for active items
        apply_Filter(true, 0, 10, (skipactive - 1) * 10 + 10, 0, "active");

        // Set email template based on emailData
        if (emailData) {
          setemailTemplate({
            acceptanceFromCompany: emailData?.clientReceivesIndentMail?.from,
            acceptanceCCCompany: emailData?.clientReceivesIndentMail?.cc,
            acceptanceContentCompany:
              emailData?.clientReceivesIndentMail?.content,
            acceptanceSubjectCompany:
              emailData?.clientReceivesIndentMail?.subject,
            acceptanceFromTransporter:
              emailData?.transporterReceivesIndentMail?.from,
            acceptanceCCTransporter:
              emailData?.transporterReceivesIndentMail?.cc,
            acceptanceContentTransporter:
              emailData?.transporterReceivesIndentMail?.content,
            acceptanceSubjectTransporter:
              emailData?.transporterReceivesIndentMail?.subject,
            updateFromCompany: emailData?.clientReceivesIndentEditMail?.from,
            updateCCCompany: emailData?.clientReceivesIndentEditMail?.cc,
            updateContentCompany:
              emailData?.clientReceivesIndentEditMail?.content,
            updateSubjectCompany:
              emailData?.clientReceivesIndentEditMail?.subject,
            updateFromTransporter:
              emailData?.transporterReceivesIndentEditMail?.from,
            updateCCTransporter:
              emailData?.transporterReceivesIndentEditMail?.cc,
            updateContentTransporter:
              emailData?.transporterReceivesIndentEditMail?.content,
            updateSubjectTransporter:
              emailData?.transporterReceivesIndentEditMail?.subject,
            cancelFromCompany: emailData?.clientReceivesIndentCancelMail?.from,
            cancelCCCompany: emailData?.clientReceivesIndentCancelMail?.cc,
            cancelContentCompany:
              emailData?.clientReceivesIndentCancelMail?.content,
            cancelSubjectCompany:
              emailData?.clientReceivesIndentCancelMail?.subject,
            cancelFromTransporter:
              emailData?.transporterReceivesIndentCancelMail?.from,
            cancelCCTransporter:
              emailData?.transporterReceivesIndentCancelMail?.cc,
            cancelContentTransporter:
              emailData?.transporterReceivesIndentCancelMail?.content,
            cancelSubjectTransporter:
              emailData?.transporterReceivesIndentCancelMail?.subject,
            allocateFromCompany:
              emailData?.clientReceivesTruckAllocationMail?.from,
            allocateCCCompany: emailData?.clientReceivesTruckAllocationMail?.cc,
            allocateContentCompany:
              emailData?.clientReceivesTruckAllocationMail?.content,
            allocateSubjectCompany:
              emailData?.clientReceivesTruckAllocationMail?.subject,
            allocateFromTransporter:
              emailData?.transporterReceivesTruckAllocationMail?.from,
            allocateCCTransporter:
              emailData?.transporterReceivesTruckAllocationMail?.cc,
            allocateContentTransporter:
              emailData?.transporterReceivesTruckAllocationMail?.content,
            allocateSubjectTransporter:
              emailData?.transporterReceivesTruckAllocationMail?.subject,
            privateFromCompany: emailData?.clientReceivesPmMail?.from,
            privateCCCompany: emailData?.clientReceivesPmMail?.cc,
            privateContentCompany: emailData?.clientReceivesPmMail?.content,
            privateSubjectCompany: emailData?.clientReceivesPmMail?.subject,
            privateFromTransporter: emailData?.transporterReceivesPmMail?.from,
            privateCCTransporter: emailData?.transporterReceivesPmMail?.cc,
            privateContentTransporter:
              emailData?.transporterReceivesPmMail?.content,
            privateSubjectTransporter:
              emailData?.transporterReceivesPmMail?.subject,
          });
        }
        // Fetch truck types
        getTruckTypes();

        // Hide loader if planning button is not true
        if (!planningbutton) {
          setshow(false);
        }

        // Update allowed view indent state based on user policy
        if (userDetails?.policy && userDetails?.policy?.type) {
          setallowed_view_indent(
            userDetails?.policy?.indents &&
              userDetails?.policy?.indents?.allowed === "yes" &&
              userDetails?.policy?.indents?.allowed_view_company_indent ===
              "yes"
              ? true
              : false
          );
        }
      }
    }

    //setshow(false);
  }, [companyProfile, userDetails]); // Dependency array

  /**
   * Closes the chat modal and triggers data reload.
   * This function calls `reload_data` with `filtered_details` as an argument.
   */
  const closechatModal = () => {
    reload_data(filtered_details);
  };

  /**
   * Reloads the data and updates the chat interface.
   * @param {Array} data - The array of data objects that contains chat indent information.
   * Each object should have an `indent_id` property.
   * This function sends a POST request with the payload containing shard IDs derived from the provided data.
   * On successful response, it updates the `noofenq` property of each data object with the unread count from the response.
   * It also updates the state with the modified data and handles UI visibility.
   * @returns {void} - This function does not return a value.
   */
  const reload_data = (data) => {
    setshow(true);

    var payload = {
      shard_ids: data.length > 0 ? data.map((indent) => indent.indent_id) : [],
    };

    axios
      .post(
        `${Urls.indent_chat}&email=${company_mail}&id_specific=true`,
        payload
      )
      .then((r) => {
        var indents = data.map((i) => {
          r.data.map((ml) => {
            if (i.indent_id === ml.indent_id) {
              i.noofenq = ml.transporter_unread_count;
            }
            return null;
          });
          return i;
        });

        if (setfiltered_details) {
          setfiltered_details(indents);
        }
        setshow(false);
      })
      .catch((e) => {
        setshow(false);
        console.log(e);
      });
  };

  /**
   * Fetches the list of truck types from the server and updates the state.
   * This function sends a GET request to retrieve truck types and formats the response.
   * @returns {void} - This function does not return a value.
   */
  const getTruckTypes = () => {
    axios
      .get(`${Urls.Autocomplete.Get.getlist}?searchFields=truck&include_company_trucks=true`)
      .then((res) => {
        var myTrucks = [];
        var otherTrucks = [];
        res.data.forEach((item) => {
          if (item.name) {
            if (item.from_truck_master) {
              myTrucks.push({ label: item.name, value: item.name, isMyTruck: true });
            } else {
              otherTrucks.push({ label: item.name, value: item.name, isMyTruck: false });
            }
          }
        });
        setTruckTypes([
          { label: "My trucks", options: myTrucks },
          { label: "Other Trucks", options: otherTrucks },
        ]);
      })
      .catch((err) => {
        setshow(false);
      });
  };

  /**
   * Validates input fields and processes data for procurement.
   * This function checks various conditions and alerts the user if validation fails.
   * If all validations pass, it prepares data and calls `gettransporterData`.
   * @returns {void} - This function does not return a value.
   */
  const addLanetoProcurement = () => {
    // var str = "1.5";  // Example string for validation
    var re = /^[-+]?[0-9]+\.[0-9]+$/; // Regex for decimal numbers
    const validPattern = /^[0-9.,\-]+$/; // Regex for valid truck required pattern
    // var found = str.match(re); // Example usage of regex

    // Validate fields
    if (
      origin.location_name === undefined ||
      destination.location_name === undefined
    ) {
      alert("Please Enter Origin and Destination");
    } else if (origin.location_name !== inputorigin) {
      alert("Please Enter Valid Origin");
    } else if (destination.location_name !== inputdestination) {
      alert("Please Enter Valid Destination");
    } else if (selectedTrucks.length === 0) {
      alert("Please Enter Truck Type");
    } else if (truckrequired <= 0) {
      alert("Truck required cannot be negative or zero");
    } else if (truckrequired === undefined || truckrequired === null) {
      alert("Truck required cannot be negative or zero");
    } else if (!validPattern.test(truckrequired)) {
      alert("Please enter valid trucks required!");
    } else if (truckrequired.match(re)) {
      alert("Truck required cannot be decimal");
    } else if (origin.location_name === destination.location_name) {
      alert("Origin and destination cannot be same");
    } else if (date === "") {
      alert("Please select placement date");
    } else {
      // Prepare data for submission
      const data = {
        origin,
        destination,
        truck_types: selectedTrucks,
        truck_required: truckrequired,
        placement_date: date,
        dop_start_time: dopStartTime,
        dop_end_time: dopEndTime,
        inputOrigin: inputorigin,
        inputDestination: inputdestination,
      };

      gettransporterData(data);

      trackIndentEvent("indent request", "user has added new lane to create indent (step 1)", `lane details : ${data}`)

      // Reset form fields
      setorigin({});
      setdestination({});
      setinputorigin("");
      setinputdestination("");
      setselectedTrucks([]);
      settruckrequired(0);
    }
    settruckrequired("");
  };

  /**
   * Fetches transporter data based on the provided master data and updates the state.
   * This function sends a POST request to get transporter details and processes the response.
   * @param {Object} master_data - The data object containing origin, destination, truck types, etc.
   * @param {Object} [data] - Optional additional data to be sent with the request (not used in the function).
   * @returns {void} - This function does not return a value.
   */
  const gettransporterData = (master_data, data) => {
    setshow(true);
    axios
      .post(`${Urls.freight_transporter}?module=indents`, {
        lanes: [
          {
            origin: master_data.origin,
            destination: master_data.destination,
            truck_type: master_data.truck_types[0],
          },
        ],
      })
      .then((res) => {
        if (res.data) {
          var temp = res.data.transporter_list[0]
            ? res.data.transporter_list[0].transporter_details
            : [];
          var list = [];
          temp.map((item) => {
            list.push(item.transporter);
            item.transporter.is_shortlist = true;
            item.rate = parseFloat(item.rate);
            if (item.rank && typeof item.rank === "string") {
              if (item.rank.includes("L")) {
                item.rank = item.rank.replace(/L(?!.*L)/g, "");
              } else {
                item.rank = `L${item.rank}`;
              }
            }
            item.business_share = parseInt(item.business_share);
            return item;
          });
          // setshow(false);
          axios
            .post(`${Urls.freight_master}?action=check_lane`, {

              lanes: [
                {
                  origin: master_data.origin,
                  destination: master_data.destination,
                  truck_type: master_data.truck_types[0],
                },
              ],
            })
            .then((res) => {
              //setshow(false);
              setshow(true);
              if (res.data.exists && res.data.exists.exists === "yes") {
                if (planningbutton) {
                  setsend_data([
                    ...send_data,
                    {
                      origin: origin,
                      destination: destination,
                      truck_types: selectedTrucks,
                      truck_required: truckrequired,
                      placement_date: date,
                      freightid: res.data.exists.freight_id,
                      shortlisted_transporters: list,
                      from: "planning",
                      email: localStorage.getItem("useremail"),
                      assigned_to: localStorage.getItem("useremail"),
                      assigned_by: localStorage.getItem("useremail"),
                    },
                  ]);
                }
                setsend_data([
                  ...send_data,
                  {
                    origin: origin,
                    destination: destination,
                    truck_types: selectedTrucks,
                    truck_required: truckrequired,
                    placement_date: date,
                    freightid: res.data.exists.freight_id,
                    shortlisted_transporters: list,
                  },
                ]);
                setshow(false);
              } else {
                list = [
                  {
                    transporter: {},
                    rank: 1,
                    rate: 0,
                    business_share: 0,
                  },
                ];
                setsend_data([
                  ...send_data,
                  {
                    origin: origin,
                    destination: destination,
                    truck_types: selectedTrucks,
                    truck_required: truckrequired,
                    placement_date: date,
                    shortlisted_transporters: list,
                    dop_start_time: dopStartTime,
                    dop_end_time: dopEndTime,
                  },
                ]);
                setshow(false);
                // settransporterData(list)
              }
            })
            .catch((err) => {
              console.log(err);
              setshow(false);
            })
            .finally(() => {
              setshow(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setshow(false);
      }).finally(() => {
        setshow(false);
      })
  };

  /**
   * Sends an email notification for the given indent item.
   * @param {Object} item - The indent item containing information for the email.
   * @returns {void}
   */
  const sendMail = (item) => {
    // Retrieve company email from local storage
    var company_mail = localStorage.getItem("useremail");
    const user_name = localStorage.getItem("user_name");
    // Create an HTML table with indent details
    var indent_table = `<table border="1">
                            <thead>
                                <th>Indent Request ID</th>
                                <th>Origin</th>
                                <th>Destination</th>
                                <th>Truck Type</th>
                                <th># trucks requested</th>
                                <th>Date of Placement</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>${item.display_indent_id}</td>
                                    <td>${item.indent_info.origin.location_name}</td>
                                    <td>${item.indent_info.destination.location_name}</td>
                                    <td>${item.indent_info.truck_types[0].value}</td>
                                    <td>${item.indent_info.truck_required}</td>
                                    <td>${item.indent_info.placement_date}</td>
                                </tr>
                            </tbody>
                        </table>`;

    // Prepare the email body for the company
    const emailBody = {
      activity: "Email Request",
      type: "superlaunch",
      mail_status: "Pending",
      from_email:
        emailTemplate.cancelFromCompany === "user"
          ? localStorage.getItem("useremail")
          : "connect@logisticsnow.in",
      user_type: "company",
      cc: "connect@logisticsnow.in",
      subject: eval("`" + emailTemplate.cancelSubjectCompany + "`"),
      content: eval("`" + emailTemplate.cancelContentCompany + "`"),
      to_email: `${company_mail}`,
      Application_name: "lorri",
      module_name: "Indents",
      timestamp: currentRequestTimeStamp(),
    };
    mailerAPI(emailBody, setshow);

    if (item) {
      var list = [];
      item?.indent_info?.shortlisted_transporters?.map((transporter) => {
        if (
          transporter?.is_shortlist === true &&
          transporter?.access_control?.length > 0
        ) {
          if (!list?.includes(transporter.transporter_id)) {

            transporter?.access_control?.map((poc) => {
              if (
                checkModuleAccess(
                  transporter.access_control,
                  poc.contact_number,
                  "Indent",
                  item.company_name
                )
              ) {
                let transporter_poc_name = poc?.name;
                let company_name = item.company_name;
                var emailTransporterBody = {
                  activity: "Email Request",
                  Application_name: "lorri",
                  module_name: "Indents",
                  timestamp: currentRequestTimeStamp(),
                  type: "superlaunch",
                  mail_status: "Pending",
                  from_email: "lorri@logisticsnow.com",
                  user_type: "transporter",
                  cc: "connect@logisticsnow.in",
                  subject: eval(
                    "`" + emailTemplate.cancelSubjectTransporter + "`"
                  ),
                  content: eval(
                    "`" + emailTemplate.cancelContentTransporter + "`"
                  ),
                  to_email: `${poc.email}`,
                };
                mailerAPI(emailTransporterBody, setshow);

                // removed sms logic from here

                return poc;
              }
            });
          }
        }
        return transporter;
      });
    }
    // No return statement needed as this function does not return a value.
  };

  /**
   * Creates and sends an email notification about new indents.
   * @param {Object} data - The data object containing information about the indents.
   * @returns {void}
   */
  const createIndentMail = (data) => {
    // Retrieve company details from local storage
    var company_name = localStorage.getItem("companyname");
    var company_mail = localStorage.getItem("useremail");
    // var company_list = company_mail.split("@")
    // var company = company_list[1].split('.')[0]
    // Create an HTML table with indent details
    var indent_table = `<table border="1">
                            <thead>
                                <th>Indent ID</th>
                                <th>Created On</th>
                                <th>Origin</th>
                                <th>Destination</th>
                                <th>Truck Type</th>
                                <th># Trucks Required</th>
                                <th>Date of Placement/ Contract</th>
                            </thead>
                            <tbody>
                                ${data.data.map((indent) => {
      return `<tr>
                                    <td>${indent.display_indent_id}</td>
                                    <td>${indent.created_date}</td>
                                    <td>${indent.indent_info.origin
          ? indent.indent_info.origin
            .location_name
          : "NA"
        }</td>
                                    <td>${indent.indent_info.destination
          ? indent.indent_info.destination
            .location_name
          : "NA"
        }</td>
                                    <td>${indent.indent_info.truck_types[0].value
        }</td>
                                    <td>${indent.indent_info.truck_required
        }</td>
                                    <td>${indent.indent_info.placement_date
        }</td>
                                </tr>`;
    })}
                            </tbody>
                        </table>`;

    // Prepare the email body for the company
    var emailBody = {
      activity: "Email Request",
      type: "superlaunch",
      mail_status: "Pending",
      from_email:
        emailTemplate.acceptanceFromCompany === "user"
          ? localStorage.getItem("useremail")
          : "connect@logisticsnow.in",
      user_type: "company",
      cc:
        emailTemplate.acceptanceCCCompany &&
          emailTemplate.acceptanceCCCompany !== ""
          ? "connect@logisticsnow.in"
          : "connect@logisticsnow.in",
      subject: eval("`" + emailTemplate.acceptanceSubjectCompany + "`"),
      to_email: `${company_mail}`,
      Application_name: "lorri",
      module_name: "Indents",
      timestamp: currentRequestTimeStamp(),
      content: eval("`" + emailTemplate.acceptanceContentCompany + "`"),
    };
    mailerAPI(emailBody, setshow);
    if (data) {
      var list = [];
      data.data.map((it) =>
        it.indent_info.shortlisted_transporters.map((transporter) => {
          if (planningbutton) {
            transporter.contact_information =
              transporter.transporter.contact_information;
            transporter.access_control = transporter.transporter.access_control;
          }
          if (
            (transporter.is_shortlist &&
              transporter.contact_information &&
              transporter.contact_information.length > 0) ||
            (transporter.is_shortlist &&
              transporter.access_control &&
              transporter.access_control.length > 0)
          ) {
            if (!list.includes(transporter.transporter_id)) {
              // list.push(transporter.transporter_id)
              transporter.contact_information.map((poc) => {
                if (
                  checkModuleAccess(
                    transporter.access_control,
                    poc.contact_number,
                    "Indent",
                    it.company_name
                  )
                ) {
                  //     if(access_poc[0].company_accessible.filter((company) => company.company_name === it.company_name)){
                  var localtable = `<table border="1">
                                                <thead>
                                                    <th>Sr. No.</th>
                                                    <th>Indent ID</th>
                                                    <th>Created On</th>
                                                    <th>Origin</th>
                                                    <th>Destination</th>
                                                    <th>Truck Type</th>
                                                    <th># Trucks Required</th>
                                                    <th>Date of Placement/ Contract</th>
                                                </thead>
                                                <tbody>
                                                    ${data.data.map(
                    (elt, index) => {
                      return `<tr>
                                                            <td>${index + 1
                        }</td>
                                                            <td>${elt.display_indent_id
                        }</td>
                                                            <td>${elt.created_date
                        }</td>
                                                            <td>${elt.indent_info
                          .origin
                          .location_name
                        }</td>
                                                            <td>${elt.indent_info
                          .destination
                          .location_name
                        }</td>
                                                            <td>${Array.isArray(
                          elt.indent_info
                            .truck_types
                        )
                          ? elt.indent_info.truck_types.map(
                            (ttt) =>
                              ttt.value
                          )
                          : elt
                            .indent_info
                            .truck_types
                            .label
                        }</td>
                                                            <td>${elt.indent_info
                          .truck_required
                          ? elt
                            .indent_info
                            .truck_required
                          : "NA"
                        }</td>
                                                            <td>${elt.indent_info
                          .placement_date
                          ? elt
                            .indent_info
                            .placement_date
                          : "NA"
                        }</td>
                                                        </tr>`;
                    }
                  )}
                                                </tbody>
                                            </table>`;

                  // Prepare the email body for the transporter
                  var emailTransporterBody = {
                    activity: "Email Request",
                    Application_name: "lorri",
                    module_name: "new enquiry",
                    timestamp: currentRequestTimeStamp(),
                    type: "superlaunch",
                    mail_status: "Pending",
                    from_email:
                      emailTemplate.acceptanceFromTransporter === "user"
                        ? localStorage.getItem("useremail")
                        : "lorri@logisticsnow.com",
                    user_type: "transporter",
                    cc:
                      emailTemplate.acceptanceCCTransporter &&
                        emailTemplate.acceptanceCCTransporter !== ""
                        ? "lorri@logisticsnow.in"
                        : "lorri@logisticsnow.in",
                    subject: eval(
                      "`" + emailTemplate.acceptanceSubjectTransporter + "`"
                    ),
                    content: eval(
                      "`" + emailTemplate.acceptanceContentTransporter + "`"
                    ),
                    to_email: `${poc.email}`,
                  };
                  mailerAPI(emailTransporterBody, setshow);
                  if (
                    poc.contact_number &&
                    (poc.contact_number !== null) &
                    (poc.contact_number !== undefined)
                  ) {
                    var contact = poc.contact_number.split("+91");
                    if (contact[0] === "") {
                      var smsTransporterBody = {
                        activity: "message_request",
                        type: "fast2sms",
                        sender_id: "LORRII",
                        message: "144529",
                        contact_number: `${contact[1]}`,
                        message_status: "Pending",
                        user_id: localStorage.getItem("oid"),
                        timestamp: currentRequestTimeStamp(),
                        transporter_name: transporter.transporter_name,
                        route: "dlt",
                        transporter_id: transporter.transporter_id,
                        title: "LoRRI Indent",
                        content: `New indent received for ${it.indent_info.origin.location.location
                          } TO ${it.indent_info.destination.location.location}, ${Array.isArray(it.indent_info.truck_types)
                            ? it.indent_info.truck_types.map((ttt) => {
                              return ttt.value;
                            })
                            : it.indent_info.truck_types.label
                          } from ${company_name}. Login to transporter.lorri.in to accept or reject indent. -Sent via Team LoRRI`,
                        subtitle: "",
                        body: `${company_name}, ${it.indent_info.origin.location.location} ➤ ${it.indent_info.destination.location.location}`,
                      };
                      mailerAPI(smsTransporterBody, setshow);
                    } else {
                      var smsTransporterBody = {
                        activity: "message_request",
                        type: "fast2sms",
                        sender_id: "LORRII",
                        message: "144529",
                        contact_number: `${contact[0]}`,
                        message_status: "Pending",
                        user_id: localStorage.getItem("oid"),
                        timestamp: currentRequestTimeStamp(),
                        transporter_id: transporter.transporter_id,
                        transporter_name: transporter.transporter_name,
                        route: "dlt",
                        title: "LoRRI Indent",
                        content: `New indent received for ${it.indent_info.origin.location.location
                          } TO ${it.indent_info.destination.location.location}, ${Array.isArray(it.indent_info.truck_types)
                            ? it.indent_info.truck_types.map((ttt) => {
                              return ttt.value;
                            })
                            : it.indent_info.truck_types.label
                          } from ${company_name}. Login to transporter.lorri.in to accept or reject indent. -Sent via Team LoRRI`,
                        subtitle: "",
                        body: `${company_name}, ${it.indent_info.origin.location.location} ➤ ${it.indent_info.destination.location.location}`,
                      };

                      mailerAPI(smsTransporterBody, setshow);
                    }
                  }
                  list.push(transporter.transporter_id);
                }
              });
            }
          }
        })
      );
    }
    // No return statement needed as this function does not return a value.
  };

  /**
   * Updates the truck required value for a specific item.
   * @param {number} value - The new truck required value.
   * @param {Object} item - The item to be updated.
   * @param {number} index - The index of the item in the list.
   * @returns {void}
   */
  const onInputChange = (value, item, index) => {
    // Update the truck required value for the item
    item.truck_required = value;
  };

  /**
   * Updates the document details for a specific item.
   * @param {string} value - The new document details value.
   * @param {Object} item - The item to be updated.
   * @param {number} index - The index of the item in the list (currently unused).
   * @returns {void}
   */
  const onChangeDoc = (value, item, index) => {
    item.document_details = value;
  };

  /**
   * Updates the placement date for a specific item.
   * @param {string} value - The new placement date value.
   * @param {Object} item - The item to be updated.
   * @param {number} index - The index of the item in the list (currently unused).
   * @returns {void}
   */
  const onEditDate = (value, item, index) => {
    item.placement_date = value;
    // No return statement needed as this function does not return a value.
  };
  const onEditStartTime = (value, _item, index) => {
    setsend_data(prev => {
      const next = [...prev];
      next[index] = { ...next[index], dop_start_time: value };
      return next;
    });
  };

  const onEditEndTime = (value, _item, index) => {
    setsend_data(prev => {
      const next = [...prev];
      next[index] = { ...next[index], dop_end_time: value };
      return next;
    });
  };


  /**
   * Closes the modal with the ID "close_contactus".
   * @returns {void}
   */
  const closeModal = () => {
    const closeBtn = document.getElementById("close_contactus");
    if (closeBtn) {
      closeBtn.click();
    }
  };

  /**
   * Closes the private market modal and applies a filter to update the view.
   * This function calls `apply_Filter` with specific parameters to refresh the data
   * based on the current pagination and filter settings, and then updates the `skipactive`
   * state to the current value.
   * @returns {void}
   */
  const closePrivateMarketModal = () => {
    apply_Filter(true, 0, 10, (skipactive - 1) * 10 + 10, 0, indentBucket);
    setSkipactive(skipactive);
  };

  const onChangeTruckTypessenddata = (value, item) => {
    var list = [];
    list.push(value);
    item.truck_types = list;
  };

  const [filters_applied, setFilters_applied] = useState(false);

  const handleFilterApply = (payload) => {
    setIsFilterActive(true);

    if (payload.company_id) delete payload.company_id;
    if (payload.date_range) delete payload.date_range;
    if (payload.filter_opertaion) delete payload.filter_opertaion;

    if (payload.view) {
      setuserview(payload.view === "company_view" ? false : true);
      setIndentLevel(payload.view);
    }
    if (payload.bucket) {
      setIndentBucket(payload.bucket);
    }

    setFilterPayload(payload);
    apply_Filter(true, 0, payload.pagination?.limit || 10, 0, null, payload.bucket || indentBucket, payload, payload.view, true);
    setShowNewFilter(false);
  };

  const handleFilterReset = () => {
    setIsFilterActive(false);
    setFilterPayload(null);
    setuserview(true);
    setIndentLevel("user_view");
    setIndentBucket("active");
    apply_Filter(true, 0, 10, 0, null, "active", { filters: [], search: "", sort: { key: "created_date", order: "desc" } }, "user_view");
    setShowNewFilter(false);
    toast.info("Filters reset");
  };

  const DEFAULT_SORT_OPTIONS = [
    { label: "Created Date", value: "created_date" },
  ];

  const renderActiveFilters = () => {
    if (!isFilterActive || !filterPayload) return null;

    const hasFilters = filterPayload.filters && filterPayload.filters.length > 0;
    const hasSearch = filterPayload.search && filterPayload.search.trim() !== "";
    const currentSortKey = filterPayload.sort?.key;
    const isDefaultSort = currentSortKey === "created_date" || !currentSortKey;
    const currentSortLabel = DEFAULT_SORT_OPTIONS.find(o => o.value === currentSortKey)?.label || currentSortKey;
    const hasSort = !isDefaultSort;

    const currentLimit = filterPayload.pagination?.limit;
    const hasPagination = currentLimit && currentLimit !== 10;

    const hasBucket = filterPayload.bucket && filterPayload.bucket !== "active";
    const hasView = filterPayload.view && filterPayload.view !== "user_view";

    if (!hasFilters && !hasSearch && !hasSort && !hasBucket && !hasView && !hasPagination) return null;

    const removeFilter = (filterKey) => {
      const updatedFilters = filterPayload.filters.filter(f => f.key !== filterKey);
      if (updatedFilters.length === 0 && (!filterPayload.search || filterPayload.search.trim() === "") && !hasSort) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          filters: updatedFilters,
          pagination: { ...filterPayload.pagination, skip: 0 },
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const clearSearch = () => {
      const updatedPayload = { ...filterPayload, search: "" };
      if ((!updatedPayload.filters || updatedPayload.filters.length === 0) && !hasSort) {
        handleFilterReset();
      } else {
        const resetPayload = {
          ...filterPayload,
          search: "",
          pagination: { ...filterPayload.pagination, skip: 0 }
        };
        setFilterPayload(resetPayload);
        handleFilterApply(resetPayload);
      }
    };

    const resetSort = () => {
      const updatedPayload = { ...filterPayload, sort: { key: "created_date", order: "desc" } };
      if (!hasFilters && (!filterPayload.search || filterPayload.search.trim() === "") && (updatedPayload.bucket === "active" || !updatedPayload.bucket) && (updatedPayload.view === "user_view" || !updatedPayload.view)) {
        handleFilterReset();
      } else {
        const sortedPayload = {
          ...filterPayload,
          sort: { key: "created_date", order: "desc" },
          pagination: { ...filterPayload.pagination, skip: 0 }
        };
        setFilterPayload(sortedPayload);
        handleFilterApply(sortedPayload);
      }
    };

    const resetBucket = () => {
      const updatedPayload = { ...filterPayload, bucket: "active" };
      setIndentBucket("active");
      if ((!updatedPayload.filters || updatedPayload.filters.length === 0) && (!updatedPayload.search || updatedPayload.search.trim() === "") && (updatedPayload.view === "user_view" || !updatedPayload.view)) {
        handleFilterReset();
      } else {
        handleFilterApply(updatedPayload);
      }
    };

    const resetPagination = () => {
      const updatedPayload = {
        ...filterPayload,
        pagination: { ...filterPayload.pagination, limit: 10, skip: 0 },
      };
      if (!hasFilters && (!filterPayload.search || filterPayload.search.trim() === "") && !hasSort && (updatedPayload.bucket === "active" || !updatedPayload.bucket) && (updatedPayload.view === "user_view" || !updatedPayload.view)) {
        handleFilterReset();
      } else {
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const resetView = () => {
      const updatedPayload = { ...filterPayload, view: "user_view" };
      setuserview(true);
      if ((!updatedPayload.filters || updatedPayload.filters.length === 0) && (!updatedPayload.search || updatedPayload.search.trim() === "") && (updatedPayload.bucket === "active" || !updatedPayload.bucket)) {
        handleFilterReset();
      } else {
        handleFilterApply(updatedPayload);
      }
    };

    const getBucketLabel = (val) => {
      switch (val) {
        case "active": return "Active";
        case "cancelled": return "Cancelled";
        case "expired": return "Expired";
        default: return val;
      }
    };

    const getViewLabel = (val) => {
      switch (val) {
        case "user_view": return "My Indents";
        case "company_view": return "Company Indents";
        default: return val;
      }
    };

    const formatValue = (value) => {
      if (Array.isArray(value)) return value.join(", ");
      return value;
    };

    return (
      <div className={classes1.activeFiltersArea}>
        <div className={classes1.filterHeader}>
          <i className="fa fa-filter mr-2 text-primary" />
          <span className={classes1.filterHeaderLabel}>Active Filters</span>
        </div>

        <div className={classes1.filterPillsContainer}>
          {filterPayload.view && filterPayload.view !== "user_view" && (
            <div className={classes1.filterPill}>
              <span className={classes1.filterPillContent}>
                <i className="fa fa-eye mr-1 text-primary" style={{ fontSize: "10px" }} />
                <strong className={classes1.filterPillTitle}>View:</strong> {getViewLabel(filterPayload.view)}
              </span>
              {filterPayload.view !== "user_view" && (
                <i className={`fa fa-times-circle ${classes1.filterRemoveBtn}`} onClick={resetView} />
              )}
            </div>
          )}

          {filterPayload.bucket && filterPayload.bucket !== "active" && (
            <div className={classes1.filterPill}>
              <span className={classes1.filterPillContent}>
                <i className="fa fa-bitbucket mr-1 text-warning" style={{ fontSize: "10px" }} />
                <strong className={classes1.filterPillTitle}>Bucket:</strong> {getBucketLabel(filterPayload.bucket)}
              </span>
              {filterPayload.bucket !== "active" && (
                <i className={`fa fa-times-circle ${classes1.filterRemoveBtn}`} onClick={resetBucket} />
              )}
            </div>
          )}

          {hasSearch && (
            <div className={classes1.filterPill}>
              <span className={classes1.filterPillContent}>
                <i className="fa fa-search mr-1 text-info" style={{ fontSize: "10px" }} />
                <strong className={classes1.filterPillTitle}>Search:</strong> {filterPayload.search}
              </span>
              <i className={`fa fa-times-circle ${classes1.filterRemoveBtn}`} onClick={clearSearch} />
            </div>
          )}

          {filterPayload.filters?.filter(f => f.key !== 'bucket' && f.key !== 'view')?.map((f, i) => (
            <div key={`${f.key}_${i}`} className={classes1.filterPill}>
              <span className={classes1.filterPillContent}>
                <i className="fa fa-check-circle mr-1 text-success" style={{ fontSize: "10px" }} />
                <strong className={classes1.filterPillTitle}>{f.label || f.key}:</strong> {formatValue(f.values)}
              </span>
              <i className={`fa fa-times-circle ${classes1.filterRemoveBtn}`} onClick={() => removeFilter(f.key)} />
            </div>
          ))}

          {hasSort && (
            <div className={classes1.filterPill}>
              <span className={classes1.filterPillContent}>
                <i className="fa fa-sort mr-1 text-warning" style={{ fontSize: "10px" }} />
                <strong className={classes1.filterPillTitle}>Sort:</strong> {currentSortLabel}
              </span>
              <i className={`fa fa-times-circle ${classes1.filterRemoveBtn}`} onClick={resetSort} />
            </div>
          )}

          {hasPagination && (
            <div className={classes1.filterPill}>
              <span className={classes1.filterPillContent}>
                <i className="fa fa-list-ol mr-1 text-secondary" style={{ fontSize: "10px" }} />
                <strong className={classes1.filterPillTitle}>Limit:</strong> {currentLimit}
              </span>
              <i className={`fa fa-times-circle ${classes1.filterRemoveBtn}`} onClick={resetPagination} />
            </div>
          )}
        </div>

        <button
          className={classes1.clearAllBtn}
          onClick={handleFilterReset}
        >
          Clear All
        </button>
      </div>
    );
  };
  const [selected_indent_id, setselected_indent_id] = useState();

  const getFilterCount = () => {
    let count = 0;
    if (isFilterActive && filterPayload) {
      count += filterPayload.filters?.length || 0;
      if (filterPayload.search && filterPayload.search.trim() !== "") count++;
    }
    if (indentLevel !== "user_view") count++;
    if (indentBucket !== "active") count++;
    return count;
  };

  const apply_Filter = (firsttime, skipval, limit, skip, val, valueof, newPayload = null, viewOverride = null, showToast = false) => {
    setshow(true);
    setSkipactive(skipval);

    const activeBucket = valueof || indentBucket;
    if (activeBucket === "active") {
      setCancelledindents(false);
      setExpiredIndents(false);
      setPendingIndents(false);
      setAcceptedIndents(false)
      setRejectedIndents(false)
    } else if (activeBucket === "cancelled") {
      setCancelledindents(true);
      setExpiredIndents(false);
      setPendingIndents(false);
      setAcceptedIndents(false)
      setRejectedIndents(false)
    } else if (activeBucket === "expired") {
      setCancelledindents(false);
      setExpiredIndents(true);
      setPendingIndents(false);
      setAcceptedIndents(false)
      setRejectedIndents(false)
    } else if (activeBucket === "pending") {
      setCancelledindents(false);
      setExpiredIndents(false);
      setPendingIndents(true);
      setAcceptedIndents(false)
      setRejectedIndents(false)
    }
     else if (activeBucket === "accepted") {
      setCancelledindents(false);
      setExpiredIndents(false);
      setPendingIndents(false);
      setAcceptedIndents(true)
      setRejectedIndents(false)
    }
     else if (activeBucket === "rejected") {
      setCancelledindents(false);
      setExpiredIndents(false);
      setPendingIndents(false);
      setAcceptedIndents(false)
      setRejectedIndents(true)
    }
    setIndentBucket(activeBucket);

    const currentView = viewOverride !== null ? viewOverride : (userview ? "user_view" : "company_view");

    let payload = {
      bucket: activeBucket,
      filters: [],
      filtersOperator: "and",
      search: "",
      view: currentView,
      pagination: {
        skip: skipval > 0 ? (skipval * (limit || 10)) : 0,
        limit: limit || 10
      },
      sort: {
        key: "created_date",
        order: "desc"
      }
    };

    const activePayload = newPayload || (isFilterActive ? filterPayload : null);
    if (activePayload) {
      payload = {
        ...payload,
        ...activePayload,
        bucket: activeBucket,
        view: currentView,
        pagination: {
          skip: skipval >= 0 ? (skipval * (activePayload.pagination?.limit || limit || 10)) : (activePayload.pagination?.skip || 0),
          limit: activePayload.pagination?.limit || limit || 10
        }
      };
      if (!activePayload.filtersOperator) {
        payload.filtersOperator = "and";
      }
    }

    axios
      .post(`${Urls.indent}?field=get_indents_v2`, payload)
      .then((res) => {
        setTotalindents(res.data.total_indents);
        if (setfiltered_details) {
          setfiltered_details(res.data.indents);
        }
        reload_data(res.data.indents);
        setshow(false);
        if (showToast) {
          toast.success(`Found ${res.data.total_indents} results`);
        }
      })
      .catch((e) => {
        setshow(false);
        console.log(e);
      });
  };
  // Cleaned up legacy filter logic

  /**
   * Add New Lanes
   * @returns {void}
   */
  const AddedLanes = () => {
    var mindate = new Date();
    var day = ("0" + mindate.getDate()).slice(-2);
    var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
    var year = mindate.getFullYear();
    var todaydate =
      year.toString() + "-" + month.toString() + "-" + day.toString() + "";

    /**
     * Component that renders a bar displaying the count of accepted and rejected items.
     * @param {Object} data - The data object containing information to be displayed.
     * @param {string} data.indent_id - The ID used to identify the element for click actions.
     * @param {boolean} data.is_delete - Flag indicating if the item is deleted.
     * @param {boolean} data.is_expired - Flag indicating if the item is expired.
     * @param {number} data.accepted_count - The count of accepted items.
     * @param {number} data.rejected_count - The count of rejected items.
     * @param {Object[]} data.summary - An array of items with status to be processed.
     * @param {Object} data.summary[].indent_status - Status of the item, which can be "pending" among other values.
     * @returns {JSX.Element} The rendered bar component.
     */
    const getBar = (data) => {
      // Extract the summary array from the data object
      var temp = data.summary;

      // Initialize an array to store pending items
      var pending = [];

      // Check if the summary array exists and has items
      if (temp && temp.length > 0) {
        // Iterate over each item in the summary array
        temp.map((item) => {
          // If the item's status is "pending", add it to the pending array
          if (item.indent_status === "pending") {
            pending.push(item);
          }
          return item; // Return item (used by map but not needed here)
        });
      }

      /**
       * Function to handle the click event on the modal.
       * @param {Event} e - The click event.
       */
      const clickModal = (e) => {
        // Trigger a click event on the element with the ID from data.indent_id
        document.getElementById(data.indent_id).click();
      };

      // Render the JSX component
      return (
        <div
          onClick={(e) => clickModal(e)} // Set up click handler
          style={{
            color: "white",
            cursor: "pointer",
            display: "flex",
            height: "3%",
            width: isMobile() ? "25%" : "65%",
            marginLeft: isMobile() ? "0" : "20%",
            boxShadow: "5px 5px 5px 3px lightgrey",
          }}
        >
          <ReactTooltip
            className={`${classes["tooltip"]}`}
            id="accepted"
            place="top"
            effect="float"
            backgroundColor="#393185 !important"
          >
            <div>Indent Accepted Count</div>
          </ReactTooltip>
          <ReactTooltip
            className={`${classes["tooltip"]}`}
            id="rejected"
            place="top"
            effect="float"
            backgroundColor="#393185 !important"
          >
            <div>Indent Rejected Count</div>
          </ReactTooltip>
          <div
            data-tip
            data-for="accepted"
            id="accepted"
            style={{
              backgroundColor: `${data.is_delete || data.is_expired
                ? "darkgrey"
                : "rgba(44, 160, 44)"
                }`,
              height: "100%",
              flexBasis: "0",
              flexGrow: "1",
            }}
          >
            <u style={{ paddingLeft: isMobile() ? "35%" : "0" }}>
              {data.accepted_count}
            </u>
          </div>
          <div
            data-tip
            data-for="rejected"
            id="rejected"
            style={{
              backgroundColor: `${data.is_delete || data.is_expired
                ? "lightslategrey"
                : "rgba(214, 39, 40)"
                }`,
              height: "100%",
              flexBasis: "0",
              flexGrow: "1",
            }}
          >
            <u style={{ paddingLeft: isMobile() ? "35%" : "0" }}>
              {data.rejected_count}
            </u>
          </div>
        </div>
      );
    };

    /**
     * Handles the deletion of an indent request.
     * @param {Object} item - The indent item to be deleted.
     * @param {number} index - The index of the indent item in the list.
     * @param {string} remarks - The remarks for the deletion.
     * @returns {void}
     */
    const deleteHandlerforindent = (item, index, remarks) => {
      Activity([
        {
          screen: "Indents",
          module: "Indent Request",
          user_activity: `Cancel button clicked for lane ${item.indent_info.origin.location_name
            }_TO_${item.indent_info.destination.location_name}_${Array.isArray(item.indent_info.truck_types)
              ? item.indent_info.truck_types[0].label
              : item.indent_info.truck_types.label
            }`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);

      const data = `${item?.indent_info?.origin?.location_name || "NA"}, ${item?.indent_info?.destination?.location_name || "NA"
        }, ${item?.indent_info?.truck_types?.[0]?.label || "NA"}`;

      trackIndentEvent("indent request", "user has clicked on cancel indent button", data);

      // Check if remarks are provided
      if (remarks !== "" && remarks !== null) {
        setshow(true); // Show some UI element (e.g., a modal)

        // Send a POST request to update the indent as deleted
        axios
          .post(`${Urls.indent}?indent_id=${item.indent_id}&field=deleted`, {
            update_type: "deleted",
            remark: remarks,
          })
          .then((res) => {
            toast.success("Indent Request Cancelled"); // Show success toast notification
            // getIndents(); // Optional: Fetch updated list of indents (commented out)
            // getActiveIndents(skipactive, 10, (((skipactive-1)*10)+10)); // Optional: Fetch updated list of active indents (commented out)
            apply_Filter(
              true,
              skipactive,
              10,
              (skipactive - 1) * 10 + 10,
              0,
              "active"
            ); // Apply filter to refresh list
            sendMail(item); // Send an email notification about the cancellation
          })
          .catch((e) => {
            console.log(e); // Log any errors encountered
          });
      } else {
        alert("Please add remarks"); // Alert if no remarks are provided
      }
    };

    const AddRemarks = ({ item, index }) => {
      const [remarks, setRemarks] = useState("");

      return (
        <div>
          Add Remarks:
          <input type="text" onInput={(e) => setRemarks(e.target.value)} />
          <center>
            <button
              className="btn btn-sm btn-primary"
              onClick={(e) => deleteHandlerforindent(item, index, remarks)}
              disabled={noIndentaccess}
            >
              Submit
            </button>
          </center>
        </div>
      );
    };

    /**
     * Handles the change event for pagination and updates the UI and filters accordingly.
     * @param {number} e - The page number to navigate to, where `e` is the current page number.
     * @returns {void}
     */
    const getOnChange = (e) => {
      // Track the pagination button click event with Mixpanel
      trackIndentEvent("indent request", "user has clicked on pagination button")

      const activeLimit = filterPayload?.pagination?.limit || 10;
      const newSkip = (e - 1) * activeLimit;

      // Update the skip active page state
      setSkipactive(e - 1);

      // Check if any filters are applied
      if (isFilterActive && filterPayload) {
        const updatedPayload = {
          ...filterPayload,
          pagination: { ...filterPayload.pagination, skip: newSkip, limit: activeLimit }
        };
        setFilterPayload(updatedPayload);
        apply_Filter(false, e - 1, activeLimit, newSkip, 0, filterPayload.bucket || "active", updatedPayload);
      } else {
        // Determine which filter to apply based on the indent status
        if (cancelledindents) {
          apply_Filter(true, e - 1, activeLimit, newSkip, 0, "cancelled");
        } else if (expiredIndents) {
          apply_Filter(true, e - 1, activeLimit, newSkip, 0, "expired");
        } else {
          apply_Filter(true, e - 1, activeLimit, newSkip, 0, "active");
        }
      }
    };

    /**
     * Handles the change event for filters.
     * @param {void}
     * @returns {void}
     */
    const getNewIndents = () => {
      // getActiveIndents(0, 10, 0)
      //fetch the filtered content
      apply_Filter(true, 0, 10, 0, 0, "active");
    };

    /**
     * Renders a modal component for displaying the quotation summary of a private marketplace.
     * @param {Object} item - The item for which the quotation summary is to be displayed.
     * @param {number} index - The index of the item in the list.
     * @returns {JSX.Element} The modal component containing the quotation summary.
     */
    const quoteModal = (item, index) => {
      return (
        <Modal
          style={{ marginRight: "1px" }}
          buttonLabel={
            <>
              <i
                data-tip
                data-for="private_marketplace_summary"
                className="fas fa-shopping-cart"
              />
              <ReactTooltip
                id="private_marketplace_summary"
                place="bottom"
                effect="float"
                backgroundColor="#393185!important"
              >
                Quotation Summary of Marketplace
              </ReactTooltip>
            </>
          }
          buttonClass="btn btn-sm btn-primary paddingchat"
          content={
            <NewPrivateMarketPlace
              item={item}
              index={index}
              transporter_list={item.summary}
              getIndents={getNewIndents}
              todaydate={todaydate}
              emailTemplate={emailTemplate}
              closePrivateMarketModal={closePrivateMarketModal}
            />
          }
          title={`Quotation Summary of Private Marketplace`}
          id="closebutton"
          screenName="Indent"
          moduleName="Indent Request"
          activityName={`Private Market place button clicked for ${item.indent_info?.origin?.location_name
            }, ${item.indent_info?.destination?.location_name}, ${Array.isArray(item.indent_info?.truck_types)
              ? item.indent_info.truck_types.map((ttt) => ttt.value).join(", ")
              : item.indent_info?.truck_types?.label || ""
            }`}
          backdrop={true}
          onClose={closePrivateMarketModal}
          size="2xl"
          disabled={item.accepted_count !== 0 || isRestricted}
        />
      );
    };

    /**
     * Renders a modal component for moving an indent to the private marketplace.
     * @param {Object} item - The indent item to be moved to the private marketplace.
     * @param {number} index - The index of the item in the list.
     * @returns {JSX.Element} The modal component for the private marketplace.
     */
    const shortlistModal = (item, index) => {
      return (
        <Modal
          style={{ marginRight: "10px", marginTop: "2px" }}
          buttonLabel={
            <>
              <i
                data-tip
                data-for="private_marketplace"
                className="fas fa-shopping-cart"
              ></i>
              <ReactTooltip
                id="private_marketplace"
                place="bottom"
                effect="float"
                backgroundColor="#393185!important"
              >
                Move Indent to Marketplace
              </ReactTooltip>
            </>
          }
          buttonClass="btn btn-sm btn-primary"
          content={
            <PrivateMarketplace
              item={item}
              index={index}
              getIndents={getNewIndents}
              todaydate={todaydate}
              emailTemplate={emailTemplate}
              companyId={companyProfile?.domain_data?.company_id}
            />
          }
          title={`Private Marketplace`}
          id="closebutton"
          screenName="Indent"
          moduleName="Indent Request"
          activityName={`Private Market place button clicked for ${item.indent_info?.origin?.location_name ?? ""
            } to ${item.indent_info?.destination?.location_name ?? ""}`}
          backdrop={true}
          disabled={item.accepted_count !== 0 || item.is_expired || isRestricted} // Disable the modal if indent is accepted or expired
        />
      );
    };

    /**
     * Determines which modal to render based on the current state and item properties.
     * @param {Object} item - The item for which the modal is to be rendered.
     * @param {number} index - The index of the item in the list.
     * @returns {JSX.Element} The modal component to be rendered.
     */
    const renderPmModal = (item, index) => {
      // Check if private marketplace access is not allowed
      if (policy?.private_marketplace?.allowed === "no") {
        return shortlistModal(item, index);
      }

      // Check if there are no shortlisted transporters
      if (item?.indent_info?.shortlisted_transporters?.length === 0) {
        return shortlistModal(item, index);
      }

      // Check if automatic private marketplace handling is disabled
      if (isPrivateMarketAuto === false) {
        // Check if there is a pre-private marketplace indent ID
        if (item.indent_info.pre_pm_indent_id) {
          return quoteModal(item, index);
        } else {
          return shortlistModal(item, index);
        }
      } else {
        // Automatic handling is enabled, so show quote modal
        return quoteModal(item, index);
      }
    };

    return (
      <div style={{ width: "100%" }}>
        <Loader show={show} />
        {!isMobile() ? (
          <div
            id="added_lanes"
            style={{ width: "96%" }}
            className={`${classes1["table-div"]}`}
          >
            <table className="added-lanes-table">
              <thead
                style={{
                  textAlign: "center",
                  backgroundColor: "#f2f2f2",
                  lineHeight: "17px",
                }}
              >
                <tr>
                  <th
                    style={{
                      width: isMobile() ? "" : "7%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    Indent Request ID
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : "7%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    {" "}
                    User Name
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : "10%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    Created On
                  </th>
                  {/* <th style={{ width: isMobile() ? '' : '10%', textAlign: "center", padding: " 12px 0px 12px 0px" }} className={`text-wrap`}>Origin</th>
                                <th style={{ width: isMobile() ? '' : '10%', textAlign: "center", padding: " 12px 0px 12px 0px" }} className={`text-wrap`}>Destination</th> */}
                  <th
                    style={{
                      border: "none",
                      textAlign: "center",
                      width: "15%",
                    }}
                  >
                    Lane
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : "9%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    Truck Type
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : "6%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    # Truck Required
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : "8%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    Date of Placement
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : autoView ? "8%" : "6%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap ${classes["s-tn"]}`}
                  >
                    Indent Status
                  </th>
                  {autoView ? (
                    <th
                      style={{
                        width: isMobile() ? "" : "6%",
                        textAlign: "center",
                        padding: " 12px 0px 12px 0px",
                      }}
                      className={`text-wrap ${classes["s-tn"]}`}
                    >
                      Allocation Summary
                    </th>
                  ) : null}
                  {!autoView ? (
                    <th
                      style={{
                        width: isMobile() ? "" : "7%",
                        textAlign: "center",
                        padding: " 12px 0px 12px 0px",
                      }}
                      className={`text-wrap ${classes["s-st"]}`}
                    >
                      Allocation Status
                    </th>
                  ) : null}
                  <th
                    style={{
                      width: isMobile() ? "" : "6%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap ${classes["s-st"]}`}
                  >
                    Shortlisted Transporter(s)
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : "6%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    Send Message
                  </th>
                  <th
                    style={{
                      width: isMobile() ? "" : "8%",
                      textAlign: "center",
                      padding: " 12px 0px 12px 0px",
                    }}
                    className={`text-wrap`}
                  >
                    {cancelledindents || expiredIndents ? (
                      "View Remark"
                    ) : (
                      <i
                        data-tip
                        data-for={`information`}
                        style={{ color: "#393186", fontSize: "large" }}
                        className="fa fa-info-circle"
                        aria-hidden="true"
                      ></i>
                    )}
                    <ReactTooltip
                      id={`information`}
                      className={`${classes["tooltip"]}`}
                      place="bottom"
                      effect="float"
                      backgroundColor="#393185 !important"
                    >
                      <div className="row">
                        {/* <div className="col-sm-1">
                                        <i style={{ fontSize: 'larger' }} className="fa fa-pencil" /><br />
                                        <i style={{ fontSize: 'large', marginLeft: '-2%' }} className="fa fa-times" /><br />
                                    </div> */}
                        <div className="col-sm-12">
                          <span>
                            <i
                              style={{ fontSize: "larger" }}
                              className="fa fa-pencil"
                            />
                            - Indents can only be edited before receiving
                            acceptance from transporters.
                            <br />
                            Once a transporter accepts an indent request it can
                            no longer be edited
                          </span>
                          <br />
                          <span>
                            <i
                              style={{ fontSize: "large", marginRight: "0.5%" }}
                              className="fa fa-times"
                            />
                            - Indents can only be cancelled before trucks are
                            allocated Once trucks are <br />
                            allocated to even one transporter cancellation is no
                            longer allowed.
                          </span>
                          <br />
                        </div>
                      </div>
                      {/* <i style={{ fontSize: 'larger' }} className="fa fa-pencil" /> - Indents can only be edited before recveiving acceptance from transporters.<br />
                                                                                                Once a transporter accepts an indent request it can no longer be edited <br />
                                <i style={{ fontSize: 'large', marginLeft: '-2%' }} className="fa fa-times" /> - Indents can only be cancelled before trucks are allocated.<br />
                                                                                                                    Once trucks are allocated to even one transporter cancellation is no longer allowed. */}
                    </ReactTooltip>
                  </th>
                </tr>
              </thead>
              <tbody>

                {filtered_details && filtered_details.length > 0 ? (
                  filtered_details.map((item, index) => (
                    <tr
                      key={index}
                      style={{ borderBottom: "1px solid lightgrey" }}
                    // key={item.display_indent_id}
                    >
                      <td style={{ textAlign: "center", paddingLeft: "0.2%" }}>
                        <div className="indentWrapper">
                          <span>{item.display_indent_id}</span>

                          {item.indent_info?.from === "planning" && (
                            <>
                              <i
                                className={`fa fa-calendar-check-o ${classes1["fromPlanningIcon"]}`}
                                data-tip
                                data-for={`fromPlanning-${index}`}
                                aria-label="From Planning"
                              />
                              <ReactTooltip
                                id={`fromPlanning-${index}`}
                                place="top"
                                effect="solid"
                                backgroundColor="#393185 !important"
                              >
                                From Planning
                              </ReactTooltip>
                            </>
                          )}
                        </div>
                      </td>
                      <td style={{ textAlign: "center", paddingLeft: "0.2%" }}>
                        {item.user_list && item.user_list.length > 0
                          ? item.user_list.map((it) => {
                            return titleCase(it.user_email.split("@")[0]);
                          })
                          : null}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.created_date}
                      </td>
                      <td
                        style={{
                          border: "none",
                          textAlign: "center",
                          paddingLeft: "0%",
                        }}
                      >
                        <Popupwidget
                          buttonLabel={<div className={classes1["lanedata"]}>
                            <center>
                              <span className={classes1["laneLine"]}
                                data-tip
                                data-for={`origin${index}`}

                              >
                                {/* <i className="fa fa-map-marker" style={{color:'#393186', marginRight:'3%'}}></i> */}
                                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                  {item.indent_info.origin.location.location}
                                </span>
                                <i
                                  className="fa fa-arrow-right"
                                  style={{ padding: "3% 6%" }}
                                />
                                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                  {item.indent_info.destination.location.location}
                                </span>
                              </span>
                              <ReactTooltip
                                id={`origin${index}`}
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                Origin: {item?.indent_info?.origin?.location_name}
                                <br />
                                Destination:{" "}
                                {item.indent_info.destination.location_name}
                              </ReactTooltip>
                            </center>
                          </div>}
                          buttonClass={classes["tripType"]}
                          title="Drop Location Details"
                          content={<TransportType indent={item} />}
                          size="lg"
                        />

                        <>
                          {item?.indent_info &&
                            item.indent_info.document_details ? (
                            <div>
                              Sales Invoice No. :{" "}
                              {item.indent_info.document_details}
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                        {/* <>
                        <div>
                        <Popupwidget
                  buttonLabel={item?.indent_info?.drop ?? "ONEWAY"}
                  buttonClass={classes["tripType"]}
                  title="Drop Location Details"
                  content={<TransportType indent={item} />}
                  size="lg"
                />
                </div>
                        </> */}
                      </td>
                      {/* <td>
                          <div>
                        <Popupwidget
                  buttonLabel={item?.indent_info?.drop ?? "ONEWAY"}
                  buttonClass={classes["tripType"]}
                  title="Drop Location Details"
                  content={<TransportType indent={item} />}
                  size="lg"
                />
                </div>
                      </td> */}
                      <td style={{ textAlign: "center" }}>
                        {item.indent_info
                          ? Array.isArray(item.indent_info.truck_types)
                            ? item.indent_info.truck_types.map((ttt) => {
                              return ttt.value;
                            })
                            : item.indent_info.truck_types.label
                          : null}
                        <br />
                        {item.indent_info.tonnage ||
                          item.indent_info.capacity ? (
                          <span>
                            {" "}
                            <hr /> Weight:{" "}
                            {item.indent_info.tonnage
                              ? item.indent_info.tonnage
                              : null}{" "}
                            {item.indent_info.capacity
                              ? item.indent_info.capacity
                              : null}
                          </span>
                        ) : null}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.indent_info
                          ? item.indent_info.truck_required
                          : null}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.indent_info
                          ? (
                            <>
                              <div>

                                {item.indent_info.placement_date
                                  ? (() => {
                                    const dateStr = String(item.indent_info.placement_date).trim();
                                    const parts = dateStr.split("-");
                                    if (parts.length === 3 && parts[0].length === 4) {
                                      return `${parts[2]}-${parts[1]}-${parts[0]}`;
                                    }
                                    return dateStr;
                                  })()
                                  : "-"}
                                <ExpiryCountdown indent={item} />
                              </div>
                              {(item.indent_info.dop_start_time || item.indent_info.dop_end_time) && (
                                <div style={{ fontSize: "12px", color: "#555" }}>
                                  {formatTime(item.indent_info.dop_start_time)}{" "}
                                  {item.indent_info.dop_start_time && item.indent_info.dop_end_time
                                    ? " - "
                                    : ""}
                                  {formatTime(item.indent_info.dop_end_time)}
                                </div>
                              )}
                            </>
                          ) : (
                            "-"
                          )}
                      </td>
                      <td
                        className="pt-3"
                        style={{
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        {autoView ? (
                          <StatusBadge
                            status={
                              item?.summary?.[item?.summary?.length - 1]
                                ?.indent_status
                            }
                            type={item?.indent_type}
                          />
                        ) : (
                          <>
                            <Modal
                              id={item.indent_id}
                              // buttonLabel={<><span style={{ fontSize: '13px' }}>View</span></>}
                              // buttonClass="btn btn-link"
                              content={
                                <ViewIndentSummary
                                  item={item}
                                  autoView={autoView}
                                  skipactive={skipactive}
                                  emailTemplate={emailTemplate}
                                />
                              }
                              title={`Allocation Summary`}
                              // id="closebutton"
                              screenName="Indent"
                              moduleName="View Summary Button"
                              activityName="View Summary Button Clicked"
                              backdrop={true}
                              size="md"
                              onClose={closeModal}
                              style={{ fontSize: "13px", display: "none" }}
                            />
                            {getBar(item)}
                          </>
                        )}
                      </td>
                      {autoView ? (
                        <td style={{ textAlign: "center" }}>
                          <Modal
                            id={item.indent_id}
                            // buttonLabel={<><span style={{ fontSize: '13px' }}>View</span></>}
                            // buttonClass="btn btn-link"
                            content={
                              <ViewIndentSummary
                                item={item}
                                autoView={autoView}
                                skipactive={skipactive}
                                emailTemplate={emailTemplate}
                              />
                            }
                            title={`Allocation Summary`}
                            // id="closebutton"
                            screenName="Indent"
                            moduleName="View Summary Button"
                            size="md"
                            activityName="View Summary Button Clicked"
                            backdrop={true}
                            onClose={closeModal}
                            style={{ fontSize: "13px", display: "none" }}
                          />
                          {getBar(item)}
                        </td>
                      ) : null}
                      {!autoView ? (
                        <td>
                          <span className={"al-status"}>
                            {item.allocation_status
                              ? item.allocation_status.allocated.toString() +
                              "/" +
                              (item.allocation_status.total_trucks_requested
                                ? item.allocation_status
                                  .total_trucks_requested
                                : item.indent_info &&
                                  item.indent_info.truck_required
                                  ? item.indent_info.truck_required
                                  : "")
                              : 0 / item.indent_info &&
                                item.indent_info.truck_required
                                ? item.indent_info.truck_required
                                : ""}
                          </span>
                        </td>
                      ) : null}
                      {
                        <td style={{ textAlign: "center" }}>
                          <Modal
                            buttonLabel={
                              <span>
                                View (
                                {item.indent_info?.shortlisted_transporters
                                  ? item.indent_info.shortlisted_transporters.filter(
                                    (lsp) =>
                                      (autoView && item.rejected_count > 0) ||
                                      lsp.is_shortlist === true ||
                                      lsp.is_shortlist === "true"
                                  ).length
                                  : 0}
                                )
                              </span>
                            }
                            buttonClass="btn btn-link"
                            size="md"
                            content={
                              <ViewLsp
                                item={item}
                                readonly={true}
                                planningbutton={planningbutton}
                                setshow={setshow}
                                autoAllocation={autoView}
                              />
                            }
                            title="Shortlisted Transporters"
                            subtitle="(This Indent was allocated to the following transporters)"
                            id="closebutton"
                            screenName="Indent"
                            moduleName="Indent Request"
                            activityName={`View LSP button clicked for ${item.indent_info?.origin?.location_name || ""
                              } to ${item.indent_info?.destination?.location_name || ""
                              }`}
                            backdrop={true}
                            closeButtonId="close_contactus"
                            style={{ fontSize: "13px" }}
                          />
                        </td>
                      }

                      <td>
                        <Modal
                          style={{}}
                          buttonLabel={
                            <>
                              <i
                                style={{ color: "white", marginRight: "3px" }}
                                data-tip
                                data-for="comment_button"
                                className="fa fa-comments-o"
                              ></i>
                              <ReactTooltip
                                id="comment_button"
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185!important"
                              >
                                Chat
                              </ReactTooltip>
                              {item.noofenq ? item.noofenq : null}
                            </>
                          }
                          buttonClass={
                            item.noofenq
                              ? "btn btn-sm btn-success"
                              : "btn btn-sm btn-primary"
                          }
                          content={
                            <ViewEnquiry
                              item={item}
                              transporter_list={
                                item.indent_info &&
                                  item.indent_info.shortlisted_transporters
                                  ? item.indent_info.shortlisted_transporters
                                  : ""
                              }
                              id={item.indent_id}
                              type={"indent"}
                              moduleName={"Indent Request"}
                              screenName={"Indents"}
                            />
                          }
                          showLogo={true}
                          title="LoRRI Chat"
                          subtitle={
                            <span className={classes["s-og"]}>
                              {item.indent_info?.origin?.location_name ?? ""} to{" "}
                              {item.indent_info?.destination?.location_name ??
                                ""}
                            </span>
                          }
                          onClose={closechatModal}
                          id="editenquiry"
                          size="2xl"
                          screenName="LoRRI-Indents"
                          moduleName="indent_request"
                          activityName={`Chat button clicked for ${item.indent_info &&
                            item.indent_info.origin &&
                            item.indent_info.origin.location_name
                            ? item.indent_info.origin.location_name
                            : ""
                            } to ${item.indent_info &&
                              item.indent_info.destination &&
                              item.indent_info.destination.location_name
                              ? item.indent_info.destination.location_name
                              : ""
                            }`}
                          backdrop={true}
                          disabled={isRestricted}
                        />
                      </td>
                      <td style={{ width: !autoView ? "22%" : "8%" }}>
                        {cancelledindents || expiredIndents ? (
                          <>
                            {item.cancel_reason ? (
                              <Modal
                                buttonLabel={
                                  <>
                                    <span
                                      className="btn btn-sm btn-link"
                                      data-tip
                                      data-for={`remark${index}`}
                                    >
                                      View
                                    </span>
                                    <ReactTooltip
                                      id={`remark${index}`}
                                      className={`${classes["tooltip"]}`}
                                      place="bottom"
                                      effect="float"
                                      backgroundColor="#393185 !important"
                                    >
                                      {item.cancel_reason.length > 25
                                        ? `${item.cancel_reason.substring(
                                          0,
                                          20
                                        )}...`
                                        : item.cancel_reason}
                                    </ReactTooltip>
                                  </>
                                }
                                buttonClass="btn btn-sm btn-link"
                                size="md"
                                content={<span>{item.cancel_reason}</span>}
                                title={`Remarks`}
                                screenName="Indent"
                                moduleName="Indent Request"
                                activityName={`View Remark clicked for ${item.indent_info?.origin?.location_name ?? ""
                                  } to ${item.indent_info?.destination
                                    ?.location_name ?? ""
                                  }`}
                              />
                            ) : item.is_expired ? (
                              item.pm_pushed_indent_id ? (
                                <span
                                  data-tip
                                  data-for={`expired${index}`}
                                  className="font-italic text-muted"
                                >
                                  {" "}
                                  This Indent is Expired
                                  <ReactTooltip
                                    id={`expired${index}`}
                                    className={`${classes["tooltip"]}`}
                                    place="bottom"
                                    effect="float"
                                    backgroundColor="#393185 !important"
                                  >
                                    This Indent is Expired
                                  </ReactTooltip>
                                </span>
                              ) : isPrivateMarketAuto === false ? (
                                <Modal
                                  style={{ marginRight: "1px" }}
                                  buttonLabel={
                                    <>
                                      <i
                                        data-tip
                                        data-for="private_marketplace"
                                        className="fas fa-shopping-cart"
                                      ></i>
                                      <ReactTooltip
                                        id="private_marketplace"
                                        place="bottom"
                                        effect="float"
                                        backgroundColor="#393185!important"
                                      >
                                        Move Indent to Marketplace
                                      </ReactTooltip>
                                    </>
                                  }
                                  buttonClass="btn btn-sm btn-primary paddingchat"
                                  content={
                                    <PrivateMarketplace
                                      item={item}
                                      index={index}
                                      getIndents={getNewIndents}
                                      todaydate={todaydate}
                                      emailTemplate={emailTemplate}
                                      companyId={
                                        companyProfile.domain_data.company_id
                                      }
                                    // setnewfilters={setnewfilters}
                                    />
                                  }
                                  title={`Private Marketplace`}
                                  id="closebutton"
                                  screenName="Indent"
                                  moduleName="Indent Request"
                                  activityName={`Private Market place button clicked for ${item.indent_info?.origin?.location_name ??
                                    ""
                                    }, ${item.indent_info?.destination
                                      ?.location_name ?? ""
                                    }, ${Array.isArray(item.indent_info?.truck_types)
                                      ? item.indent_info.truck_types
                                        .map((tt) => tt.value)
                                        .join(", ")
                                      : item.indent_info?.truck_types?.label ??
                                      ""
                                    }`}
                                  backdrop={true}
                                  closeButtonId="close_contactus1"
                                  disabled={isRestricted}
                                />
                              ) : (
                                <Modal
                                  style={{ marginRight: "1px" }}
                                  buttonLabel={
                                    <>
                                      <i
                                        data-tip
                                        data-for="private_marketplace"
                                        className="fas fa-shopping-cart"
                                      ></i>
                                      <ReactTooltip
                                        id="private_marketplace"
                                        place="bottom"
                                        effect="float"
                                        backgroundColor="#393185!important"
                                      >
                                        Quotation Summary of Marketplace
                                      </ReactTooltip>
                                    </>
                                  }
                                  buttonClass="btn btn-sm btn-primary paddingchat"
                                  content={
                                    <NewPrivateMarketPlace
                                      item={item}
                                      transporter_list={item.summary}
                                      index={index}
                                      getIndents={getNewIndents}
                                      todaydate={todaydate}
                                      emailTemplate={emailTemplate}
                                      closePrivateMarketModal={
                                        closePrivateMarketModal
                                      }
                                    // setnewfilters={setnewfilters}
                                    />
                                  }
                                  title={`Quotation Summary of Private Marketplace`}
                                  id="closebutton"
                                  screenName="Indent"
                                  moduleName="Indent Request"
                                  activityName={`Private Market place button clicked for ${item.indent_info?.origin?.location_name ??
                                    ""
                                    }, ${item.indent_info?.destination
                                      ?.location_name ?? ""
                                    }, ${Array.isArray(item.indent_info?.truck_types)
                                      ? item.indent_info.truck_types
                                        .map((tt) => tt.value)
                                        .join(", ")
                                      : item.indent_info?.truck_types?.label ??
                                      ""
                                    }`}
                                  backdrop={true}
                                  onClose={closePrivateMarketModal}
                                  disabled={item.accepted_count !== 0 || isRestricted}
                                  size="2xl"
                                />
                              )
                            ) : (
                              <span>-</span>
                            )}
                          </>
                        ) : (
                          <>
                            {!autoView ? (
                              <Modal
                                style={{ marginRight: "10px", marginTop: "2px" }}
                                buttonLabel={
                                  <>
                                    <i
                                      data-tip
                                      data-for="edit_indent"
                                      className="fa fa-pencil"
                                    ></i>
                                    <ReactTooltip
                                      id="edit_indent"
                                      place="bottom"
                                      effect="float"
                                      backgroundColor="#393185!important"
                                    >
                                      Edit Indent
                                    </ReactTooltip>
                                  </>
                                }
                                buttonClass="btn btn-sm btn-primary paddingchat"
                                content={
                                  <EditIndents
                                    item={item}
                                    index={index}
                                    truck_types={TruckTypes}
                                    todaydate={todaydate}
                                    getIndents={getNewIndents}
                                    emailTemplate={emailTemplate}
                                  />
                                }
                                title={`Edit Indent-${item.display_indent_id}`}
                                id="closebutton"
                                screenName="Indent"
                                moduleName="Indent Request"
                                activityName={`Indent edit button clicked for ${item?.indent_info?.origin?.location_name || ""
                                  } to ${item?.indent_info?.destination
                                    ?.location_name || ""
                                  }`}
                                backdrop={true}
                                closeButtonId="close_contactus"
                                disabled={
                                  item.accepted_count !== 0 ||
                                  item.indent_type ===
                                  "private_market_place_indent" ||
                                  isRestricted
                                }
                              />
                            ) : null}

                            {renderPmModal(item, index)}

                            {!autoView ? (
                              item.allocation_status &&
                                item.allocation_status.allocated > 0 ? (
                                <Modal
                                  style={{ marginRight: "0px", marginTop: "0px", marginLeft: "10px" }}
                                  buttonLabel={<i className="fa fa-times" />}
                                  buttonClass="btn btn-sm btn-primary paddingchat"
                                  title={`Remarks`}
                                  content={
                                    <AddRemarks item={item} index={index} />
                                  }
                                  size="md"
                                  screenName="Indents"
                                  moduleName="Indents Request"
                                  backdrop={false}
                                  disabled
                                />
                              ) : (
                                <Modal
                                  style={{ marginRight: "0px", marginTop: "0px", marginLeft: "10px" }}
                                  buttonLabel={
                                    <>
                                      <i
                                        data-tip
                                        data-for="cancel_button"
                                        className="fa fa-times"
                                      ></i>
                                      <ReactTooltip
                                        id="cancel_button"
                                        place="bottom"
                                        effect="float"
                                        backgroundColor="#393185!important"
                                      >
                                        Cancel Indent
                                      </ReactTooltip>
                                    </>
                                  }
                                  buttonClass="btn btn-sm btn-primary paddingchat"
                                  title={`Remarks`}
                                  content={
                                    <AddRemarks item={item} index={index} />
                                  }
                                  size="md"
                                  screenName="Indents"
                                  moduleName="Indents Request"
                                  backdrop={false}
                                  disabled={
                                    item.accepted_count !== 0 || isRestricted
                                  }
                                />
                              )
                            ) : null}
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={{ height: "200px" }} colSpan="12">
                      <span style={{ fontSize: "x-large" }}>
                        <i>
                          Enter origin, destination, truck type above and click
                          on{" "}
                          <i
                            className={`fa fa-plus-circle ${classes1["s-icon1"]}}`}
                          />{" "}
                          to add an indent
                        </i>
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <>
            {filtered_details && filtered_details.length > 0 ? (
              filtered_details.map((item, index) => (
                <div className={classes1["mobile-enquiry"]}>
                  <div
                    style={{
                      display: "flex",
                      padding: "2%",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ fontSize: "13px", display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                      <b>Indent Request ID : </b>&nbsp;
                      {item.display_indent_id ? item.display_indent_id : "NA"}

                      {item.indent_info?.from === "planning" && (
                        <>
                          <i
                            className={`fa fa-calendar-check-o ${classes1["fromPlanningIcon"]}`}
                            data-tip
                            data-for={`fromPlanning-m-${index}`}
                            aria-label="From Planning"
                          />
                          <ReactTooltip
                            id={`fromPlanning-m-${index}`}
                            place="top"
                            effect="solid"
                            backgroundColor="#393185 !important"
                          >
                            From Planning
                          </ReactTooltip>
                        </>
                      )}
                    </span>
                    <span
                      style={{
                        fontSize: "13px",
                        display: "flex",
                        wordWrap: "break-word",
                      }}
                    >
                      <b>User Name : </b>
                      {item.user_list && item.user_list.length > 0
                        ? item.user_list.map((it) => {
                          return titleCase(it.user_email.split("@")[0]);
                        })
                        : null}
                    </span>
                  </div>
                  <div style={{ padding: "2%" }}>
                    <div style={{ fontSize: "13px" }}>
                      <b>Created On : </b>
                      {item.created_date ? item.created_date : "NA"}
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        justifyContent: "flex-end",
                        fontWeight: "600",
                        width: "125px",
                      }}
                    >
                      {item.indent_info ? (
                        <>
                          <i
                            className="fa fa-map-marker"
                            style={{
                              color: "#393186",
                              marginRight: "6%",
                              marginTop: "2%",
                            }}
                          />
                          <span
                            style={{ cursor: "pointer" }}
                            data-tip
                            data-for={`origin${index}`}
                          >
                            {item.indent_info.origin &&
                              item.indent_info.origin.location.suggestion.split(
                                ","
                              )[0]
                              ? item.indent_info.origin.location.suggestion.split(
                                ","
                              )[0]
                              : null}
                          </span>
                          <ReactTooltip
                            id={`origin${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="float"
                            backgroundColor="#393185 !important"
                          >
                            {item.indent_info.origin.location_name}
                          </ReactTooltip>
                        </>
                      ) : (
                        "NA"
                      )}
                    </div>
                    <i
                      className={`fa fa-arrow-right`}
                      style={{ marginTop: "1%" }}
                    />
                    <div
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        width: "125px",
                        fontWeight: "600",
                      }}
                    >
                      {item.indent_info ? (
                        <>
                          <i
                            className="fa fa-map-marker"
                            style={{
                              color: "#393186",
                              marginRight: "6%",
                              marginTop: "2%",
                            }}
                          />
                          <span
                            style={{ cursor: "pointer" }}
                            data-tip
                            data-for={`destination${index}`}
                          >
                            {item.indent_info.destination &&
                              item.indent_info.destination.location &&
                              item.indent_info.destination.location.suggestion &&
                              item.indent_info.destination.location.suggestion.split(
                                ","
                              )[0]
                              ? item.indent_info.destination.location.suggestion.split(
                                ","
                              )[0]
                              : null}
                          </span>
                          <ReactTooltip
                            id={`destination${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="float"
                            backgroundColor="#393185 !important"
                          >
                            {item.indent_info.destination.location_name}
                          </ReactTooltip>
                        </>
                      ) : (
                        "NA"
                      )}
                    </div>
                  </div>
                  <div style={{ fontSize: "14px", textAlign: "center" }}>
                    {item.indent_info
                      ? Array.isArray(item.indent_info.truck_types)
                        ? item.indent_info.truck_types.map((ttt) => {
                          return ttt.value;
                        })
                        : item.indent_info.truck_types.label
                      : null}
                  </div>
                  <div style={{ padding: "2%" }}>
                    <div style={{ fontSize: "13px", paddingBottom: "2%" }}>
                      <b># Trucks Required : </b>
                      {item.indent_info
                        ? item.indent_info.truck_required
                        : "NA"}
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        display: "flex",
                        paddingBottom: "2%",
                      }}
                    >
                      <b>Date of Placement : </b>
                      {item.indent_info
                        ? item.indent_info.placement_date
                        : "NA"}
                    </div>
                    {autoView ? (
                      <div
                        style={{
                          fontSize: "13px",
                          display: "flex",
                          paddingBottom: "2%",
                        }}
                      >
                        <b style={{ width: "27%" }}>Indent Status : </b>
                        <Modal
                          id={item.indent_id}
                          buttonLabel={
                            <span style={{ fontSize: "13px" }}>View</span>
                          }
                          buttonClass="btn btn-link"
                          content={
                            <ViewIndentSummary
                              item={item}
                              autoView={autoView}
                              skipactive={skipactive}
                              emailTemplate={emailTemplate}
                            />
                          }
                          size="md"
                          title="Allocation Summary"
                          screenName="Indent"
                          moduleName="View Summary Button"
                          activityName="View Summary Button Clicked"
                          backdrop={true}
                          onClose={closeModal}
                          style={{ fontSize: "13px", display: "none" }}
                        />
                        {getBar(item)}
                      </div>
                    ) : null}
                    <div
                      style={{
                        fontSize: "13px",
                        display: "flex",
                        paddingBottom: "2%",
                      }}
                    >
                      <b>Allocation Status : </b>
                      {item.allocation_status
                        ? item.allocation_status.allocated.toString() +
                        "/" +
                        (item.allocation_status.total_trucks_requested
                          ? item.allocation_status.total_trucks_requested
                          : item.indent_info &&
                            item.indent_info.truck_required
                            ? item.indent_info.truck_required
                            : "")
                        : 0 / item.indent_info &&
                          item.indent_info.truck_required
                          ? item.indent_info.truck_required
                          : ""}
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        display: "flex",
                        paddingBottom: "2%",
                      }}
                    >
                      <b>Shortlisted Transporters : </b>
                      <Modal
                        buttonLabel={
                          <span style={{ fontSize: "13px" }}>
                            View (
                            {item.indent_info?.shortlisted_transporters
                              ? item.indent_info.shortlisted_transporters.filter(
                                (lsp) =>
                                  (autoView && item.rejected_count > 0) ||
                                  lsp.is_shortlist === true ||
                                  lsp.is_shortlist === "true"
                              ).length
                              : 0}
                            )
                          </span>
                        }
                        buttonClass="btn btn-sm btn-link"
                        content={
                          <ViewLsp
                            item={item}
                            readonly={true}
                            planningbutton={planningbutton}
                            setshow={setshow}
                            autoAllocation={autoView}
                          />
                        }
                        title="Shortlisted Transporters"
                        subtitle="(This Indent was allocated to the following transporters)"
                        id="closebutton"
                        screenName="Indent"
                        moduleName="Indent Request"
                        activityName={`View LSP button clicked for ${item.indent_info?.origin?.location_name ?? ""
                          } to ${item.indent_info?.destination?.location_name ?? ""
                          }`}
                        backdrop={true}
                        closeButtonId="close_contactus"
                        style={{ fontSize: "13px", paddingTop: "0%" }}
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        display: "flex",
                        paddingBottom: "2%",
                      }}
                    >
                      <b>Send Message : </b>
                      <Modal
                        style={{ marginLeft: "2%" }}

                        buttonLabel={
                          <>
                            <i
                              style={{ color: "white", marginRight: "3px" }}
                              className="fa fa-comments-o"
                            ></i>
                            {item.noofenq ? item.noofenq : null}
                          </>
                        }
                        buttonClass={
                          item.noofenq
                            ? "btn btn-sm btn-success"
                            : "btn btn-sm btn-primary"
                        }
                        content={
                          <ViewEnquiry
                            item={item}
                            transporter_list={
                              item.indent_info &&
                                item.indent_info.shortlisted_transporters
                                ? item.indent_info.shortlisted_transporters
                                : ""
                            }
                            id={item.indent_id}
                            type={"indent"}
                            moduleName={"Indent Request"}
                            screenName={"Indents"}
                          />
                        }
                        showLogo={true}
                        title="LoRRI Chat"
                        subtitle={
                          <span className={classes["s-og"]}>
                            {item.indent_info?.origin?.location_name ?? ""} to{" "}
                            {item.indent_info?.destination?.location_name ?? ""}
                          </span>
                        }
                        onClose={closechatModal}
                        id="editenquiry"
                        size="2xl"
                        screenName="LoRRI-Indents"
                        moduleName="indent_request"
                        activityName={`Chat button clicked for ${item.indent_info?.origin?.location_name ?? ""
                          } to ${item.indent_info?.destination?.location_name ?? ""
                          }`}
                        backdrop={true}
                        disabled={isRestricted}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      display: "flex",
                      paddingBottom: "2%",
                    }}
                  >
                    {cancelledindents || expiredIndents ? (
                      <>
                        {item.cancel_reason ? (
                          <span>
                            <Modal
                              style={{}}
                              buttonLabel={
                                <>
                                  <span
                                    className="btn btn-sm btn-link"
                                    data-tip
                                    data-for={`remark${index}`}
                                  >
                                    View
                                  </span>
                                  <ReactTooltip
                                    id={`remark${index}`}
                                    className={`${classes["tooltip"]}`}
                                    place="bottom"
                                    effect="float"
                                    backgroundColor="#393185 !important"
                                  >
                                    {item.cancel_reason.length > 0
                                      ? `${item.cancel_reason.substring(
                                        0,
                                        20
                                      )}...`
                                      : item.cancel_reason}
                                  </ReactTooltip>
                                </>
                              }
                              buttonClass="btn btn-sm btn-link"
                              content={<span>{item.cancel_reason}</span>}
                              title={`Remarks`}
                              screenName="Indent"
                              moduleName="Indent Request"
                              activityName={`View Remark clicked for ${item.indent_info?.origin?.location_name ?? ""
                                } to ${item.indent_info?.destination?.location_name ??
                                ""
                                }`}
                              disabled={isRestricted}
                            />
                            ) : item.is_expired ? (
                            item.pm_pushed_indent_id ? (
                            <span data-tip data-for={`expired${index}`}>
                              {" "}
                              View
                              <ReactTooltip
                                id={`expired${index}`}
                                className={`${classes["tooltip"]}`}
                                place="bottom"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                This Indent Expired
                              </ReactTooltip>
                            </span>
                            ) : (
                            <Modal
                              buttonLabel={
                                <>
                                  <i
                                    data-tip
                                    data-for="private_marketplace"
                                    className="fas fa-shopping-cart"
                                  ></i>
                                  <ReactTooltip
                                    id="private_marketplace"
                                    place="bottom"
                                    effect="float"
                                    backgroundColor="#393185!important"
                                  >
                                    Move Indent to Marketplace
                                  </ReactTooltip>
                                </>
                              }
                              buttonClass="btn btn-sm btn-primary paddingchat"
                              content={
                                <PrivateMarketplace
                                  item={item}
                                  index={index}
                                  getIndents={getNewIndents}
                                  todaydate={todaydate}
                                  emailTemplate={emailTemplate}
                                  companyId={
                                    companyProfile.domain_data.company_id
                                  }
                                // setnewfilters={setnewfilters}
                                />
                              }
                              title={`Private Marketplace`}
                              id="closebutton"
                              screenName="Indent"
                              moduleName="Indent Request"
                              activityName={`Private Market place button clicked for ${item.indent_info.origin.location_name}, ${item.indent_info.destination.location_name} , ${item.indent_info.truck_types[0].label}`}
                              backdrop={true}
                              closeButtonId="close_contactus1"
                              disabled={item.accepted_count !== 0}
                              style={{ marginRight: "1px" }}
                            />
                          </span>
                        ) : (
                          <span>-</span>
                        )}
                      </>
                    ) : (
                      <>
                        <Modal
                          style={{ marginRight: "10px", marginTop: "2px" }}

                          buttonLabel={<i className="fa fa-pencil" />}
                          buttonClass="btn btn-sm btn-primary paddingchat"
                          content={
                            <EditIndents
                              item={item}
                              index={index}
                              truck_types={TruckTypes}
                              todaydate={todaydate}
                              getIndents={getNewIndents}
                              emailTemplate={emailTemplate}
                            />
                          }
                          title={`Edit Indent-${item.display_indent_id}`}
                          id="closebutton"
                          screenName="Indent"
                          moduleName="Indent Request"
                          activityName={`Indent edit button clicked for ${item.indent_info?.origin?.location_name ?? ""
                            } to ${item.indent_info?.destination?.location_name ??
                            ""
                            }`}
                          backdrop={true}
                          disabled={
                            item.accepted_count !== 0 ||
                            item.indent_type ===
                            "private_market_place_indent" ||
                            isRestricted
                          }
                        />
                        {policy?.private_marketplace?.allowed === "yes" ? (
                          <Modal
                            style={{ marginRight: "10px", marginTop: "2px" }}
                            buttonLabel={
                              <>
                                <i
                                  data-tip
                                  data-for="private_marketplace"
                                  className="fas fa-shopping-cart"
                                ></i>
                                <ReactTooltip
                                  id="private_marketplace"
                                  place="bottom"
                                  effect="float"
                                  backgroundColor="#393185!important"
                                >
                                  Move Indent to Marketplace
                                </ReactTooltip>
                              </>
                            }
                            buttonClass="btn btn-sm btn-primary paddingchat"
                            content={
                              <PrivateMarketplace
                                item={item}
                                index={index}
                                getIndents={getNewIndents}
                                todaydate={todaydate}
                                emailTemplate={emailTemplate}
                                companyId={
                                  companyProfile.domain_data.company_id
                                }
                              />
                            }
                            title={`Private Marketplace`}
                            id="closebutton"
                            screenName="Indent"
                            moduleName="Indent Request"
                            activityName={`Private Market place button clicked for ${item.indent_info?.origin?.location_name ?? ""
                              } to ${item.indent_info?.destination?.location_name ??
                              ""
                              }`}
                            backdrop={true}
                            closeButtonId="close_contactus1"
                            disabled={
                              item.accepted_count !== 0 ||
                              item.indent_type ===
                              "private_market_place_indent" ||
                              item.is_expired ||
                              isRestricted
                            }
                          />
                        ) : (
                          <Modal
                            style={{ marginRight: "10px", marginTop: "2px" }}
                            buttonLabel={
                              <>
                                <i
                                  data-tip
                                  data-for="private_marketplace"
                                  className="fas fa-shopping-cart"
                                ></i>
                                <ReactTooltip
                                  id="private_marketplace"
                                  place="bottom"
                                  effect="float"
                                  backgroundColor="#393185!important"
                                >
                                  Move Indent to Marketplace
                                </ReactTooltip>
                              </>
                            }
                            buttonClass="btn btn-sm btn-primary paddingchat"
                            content={
                              <PrivateMarketplace
                                item={item}
                                index={index}
                                getIndents={getNewIndents}
                                todaydate={todaydate}
                                emailTemplate={emailTemplate}
                                companyId={
                                  companyProfile.domain_data.company_id
                                }
                              />
                            }
                            title={`Private Marketplace`}
                            id="closebutton"
                            screenName="Indent"
                            moduleName="Indent Request"
                            activityName={`Private Market place button clicked for ${item.indent_info.origin.location_name}, ${item.indent_info.destination.location_name} , ${item.indent_info.truck_types[0].label}`}
                            backdrop={true}
                            closeButtonId="close_contactus1"
                            disabled
                          />
                        )}
                        {item.allocation_status &&
                          item.allocation_status.allocated > 0 ? (
                          <Modal
                            style={{ marginRight: "0px", marginTop: "2px" }}

                            buttonLabel={<i className="fa fa-times" />}

                            title={`Remarks`}
                            content={<AddRemarks item={item} index={index} />}
                            size="md"
                            screenName="Indents"
                            moduleName="Indents Request"
                            backdrop={false}
                            disabled
                          />
                        ) : (
                          <Modal
                            style={{ marginRight: "0px", marginTop: "2px" }}

                            buttonLabel={<i className="fa fa-times" />}

                            title="Remarks"
                            content={<AddRemarks item={item} index={index} />}
                            size="md"
                            screenName="Indents"
                            moduleName="Indents Request"
                            backdrop={false}
                            disabled={isRestricted}
                          />
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <span style={{ fontSize: "x-large" }}>
                <i>
                  Enter origin, destination, truck type above and click on{" "}
                  <i className={`fa fa-plus-circle ${classes1["s-icon1"]}}`} />{" "}
                  to add an indent
                </i>
              </span>
            )}
          </>
        )}
        {!planningbutton ? (
          <div
            className={`row page`}
            style={{
              width: "100%",
              justifyContent: "center",
              textAlign: "center",
              margin: isMobile() ? "20%" : "5px",
            }}
          >
            <Pagination
              activePage={skipactive + 1}
              itemsCountPerPage={filterPayload?.pagination?.limit || 10}
              totalItemsCount={totalindents}
              onChange={(e) => getOnChange(e)}
              itemClass="page-item"
              linkClass="page-link"
              hideDisabled
            />
          </div>
        ) : null}
      </div>
    );
  };

  /**
   * Handles the deletion of an item from the `send_data` list and performs related actions.
   * @param {Event} event - The event object associated with the delete action (e.g., click event).
   * @param {Object} item - The item to be deleted from the `send_data` list.
   * @param {number} index - The index of the item in the `send_data` list (though not used in the function).
   * @returns {void}
   */
  const deleteHandler = (event, item, index) => {
    // Log the delete action to the Activity log
    Activity([
      {
        screen: "Indents",
        module: "Indent Request",
        user_activity: `Delete button clicked for lane ${item.origin.location_name
          }_TO_${item.destination.location_name}_${Array.isArray(item.truck_types)
            ? item.truck_types[0].label
            : item.truck_types.label
          }`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    // Remove the item from the send_data list
    setsend_data(send_data.filter((data) => data !== item));

    // If there is only one item left in the send_data list
    if (send_data.length <= 1) {
      // Check if the planning button is active
      if (planningbutton) {
        // Close the contact modal by clicking the element with ID 'close_contact'
        document.getElementById("close_contact").click();
      }
    }
  };

  /**
   * Handles the change event for truck types by updating the selected trucks list.
   * @param {any} value - The new value for the truck types. The type is not explicitly specified but is expected to be a value that can be added to the list.
   * @returns {void}
   */
  const onChangeTruckTypes = (value) => {
    // Initialize a new list
    var list = [];

    // Add the new value to the list
    list.push(value);

    // Update the state with the new list of selected trucks
    setselectedTrucks(list);
  };

  const [selectedUsers, setSelectedUsers] = useState({});

  /**
   * Handles the change event for a select input, updating the selected users state.
   * @param {Event} e - The event object associated with the select input change.
   * @param {string} truckID - The ID of the truck associated with the selected value.
   * @returns {void}
   */
  const handleSelectChange = (e, truckID) => {
    // Get the selected value from the event target
    const selectedValue = e.target.value;

    // Update the state with the new selected value for the specific truckID
    setSelectedUsers((prevSelectedUsers) => ({
      ...prevSelectedUsers,
      [truckID]: selectedValue,
    }));

  };

  /**
   * Processes and splits an array of indents into individual indent entries based on truck requirements.
   * @param {Array} newindents - The array of indents to be processed and split.
   * @returns {Array} The array of splitted indents, each with a truck requirement of "1".
   */
  const splitIndents = (newindents) => {
    // Initialize the array to hold splitted indents
    let splittedIndents = [];

    // Process and split the indents
    newindents.forEach((lane) => {
      // Get the number of trucks required for the current lane
      const trucks = parseInt(lane.truck_required, 10);

      // Process shortlisted transporters and update their rank
      lane.shortlisted_transporters &&
        lane.shortlisted_transporters.length > 0 &&
        lane.shortlisted_transporters.map((data) => {
          data.rank && typeof data.rank === "string"
            ? data.rank.includes("L")
              ? (data.rank = data.rank.replace(/L(?=.*L)/g, ""))
              : (data.rank = `L${data.rank}`)
            : (data.rank = `L${data.rank}`);
        });

      // Create and push new indent entries based on the number of trucks required
      for (let i = 0; i < trucks; i++) {
        const newData = {
          ...lane,
          truck_required: "1", // Set truck required to "1" for each new entry
        };
        splittedIndents.push(newData);
      }
    });
    // Return the processed array of splitted indents
    return splittedIndents;
  };

  /**
   * Creates new indents and handles the process of floating them based on company profile settings and other conditions.
   * @param {Array} temp - The array of indent objects to be processed and created.
   * @returns {void}
   */
  const createIndent = (temp) => {
    // Show loading indicator
    setshow(true);

    // Check if company profile data is available
    if (companyProfile && companyProfile.domain_data) {
      // Check if company ID is available in the profile data
      if (
        companyProfile.domain_data.company_id &&
        companyProfile.domain_data.company_id !== ""
      ) {
        // Fetch company profile data to check indent expiry settings
        axios
          .get(
            `${Urls.companyProfile}?company_id=${companyProfile.domain_data.company_id}&projections_enable=indent`
          )
          .then((res) => {
            // Check if indent expiry settings are enabled
            if (
              res.data[0] &&
              res.data[0].indent &&
              res.data[0].indent.indent_expiry &&
              res.data[0].indent.indent_auto_expiry_enable &&
              res.data[0].indent.indent_auto_expiry_enable === "yes"
            ) {
              // Calculate new expiry dates based on company settings
              var expiryhours = res.data[0].indent.indent_expiry;
              var newindents = temp.map((data) => {
                // Calculate expiry date and time
                var expirydate = new Date();
                var hr = expirydate.getHours();
                expirydate.setHours(hr + parseInt(expiryhours));
                var finalDay = ("0" + expirydate.getDate()).slice(-2);
                var month = ("0" + (expirydate.getMonth() + 1)).slice(-2);
                var year = expirydate.getFullYear();
                var final_hr = ("0" + expirydate.getHours()).slice(-2);
                var min = ("0" + expirydate.getMinutes()).slice(-2);
                var sec = ("0" + expirydate.getSeconds()).slice(-2);
                data.expiry_date = `${year}-${month}-${finalDay} ${final_hr}:${min}:${sec}.000000`;

                // Assign selected user information if applicable
                if (data.from === "planning") {
                  data.assigned_to = selectedUsers[data.truck_id]
                    ? selectedUsers[data.truck_id]
                    : data.assigned_to;
                  data.email = selectedUsers[data.truck_id]
                    ? selectedUsers[data.truck_id]
                    : data.email;
                }
                return data;
              });

              // Post the new indents to the server
              axios
                .post(Urls.createIndent, { indents: splitIndents(newindents) })
                .then((res) => {
                  // Show success message and clear data
                  toast.success("Indents floated successfully");
                  setsend_data([]);

                  // Close modal if planning button is clicked
                  if (planningbutton) {
                    document.getElementById("close_contact").click();
                  }

                  // Handle auto view and email sending
                  // if (!autoView) {
                  //   createIndentMail(res.data);
                  // }

                  // Apply filter to update the indent list
                  apply_Filter(
                    true,
                    0,
                    10,
                    (skipactive - 1) * 10 + 10,
                    0,
                    "active"
                  );
                })
                .catch((err) => {
                  console.log(err);
                  setshow(false);
                });
            } else {
              // Handle case where indent expiry settings are not enabled
              var newindents = temp.map((data) => {
                if (data.from === "planning") {
                  data.assigned_to = selectedUsers[data.truck_id]
                    ? selectedUsers[data.truck_id]
                    : data.assigned_to;
                  data.email = selectedUsers[data.truck_id]
                    ? selectedUsers[data.truck_id]
                    : data.email;
                }
                return data;
              });

              // Post the new indents to the server
              axios
                .post(Urls.createIndent, { indents: splitIndents(newindents) })
                .then((res) => {
                  // Show success message and clear data
                  toast.success("Indents floated successfully");
                  setsend_data([]);

                  // Close modal if planning button is clicked
                  if (planningbutton) {
                    document.getElementById("close_contact").click();
                    if (update_orders) {
                      res.data.loads.map((load) => {
                        update_orders(load);
                      });
                    }
                  }

                  // Handle auto view and email sending
                  // if (!autoView) {
                  //   createIndentMail(res.data);
                  // }

                  // Apply filter to update the indent list
                  apply_Filter(
                    true,
                    0,
                    10,
                    (skipactive - 1) * 10 + 10,
                    0,
                    "active"
                  );
                })
                .catch((err) => {
                  console.log(err);
                  setshow(false);
                });
            }
          })
          .catch((err) => {
            console.log(err);
            setshow(false);
          });
      } else {
        // Handle case where company ID is not available
        var newindents = temp.map((data) => {
          if (data.from === "planning") {
            data.assigned_to = selectedUsers[data.truck_id]
              ? selectedUsers[data.truck_id]
              : data.assigned_to;
            data.email = selectedUsers[data.truck_id]
              ? selectedUsers[data.truck_id]
              : data.email;
          }
          return data;
        });

        // Post the new indents to the server
        axios
          .post(Urls.createIndent, { indents: splitIndents(newindents) })
          .then((res) => {
            // Show success message and clear data
            toast.success("Indents floated successfully");
            setsend_data([]);
            if (planningbutton) {
              document.getElementById("close_contact").click();
              // history.push("/indentrequest")
              if (update_orders) {
                res.data.loads.map((load) => {
                  update_orders(load);
                });
              }
            }
            apply_Filter(true, 0, 10, (skipactive - 1) * 10 + 10, 0, "active");
            // setshow(false)
          })
          .catch((err) => {
            console.log(err);
            setshow(false);
          });
      }
    } else {
      var newindents = temp.map((data) => {
        if (data.from === "planning") {
          data.assigned_to = selectedUsers[data.truck_id]
            ? selectedUsers[data.truck_id]
            : data.assigned_to;
          data.email = selectedUsers[data.truck_id]
            ? selectedUsers[data.truck_id]
            : data.email;
        }
        return data;
      });
      axios
        .post(Urls.createIndent, { indents: splitIndents(newindents) })
        .then((res) => {
          toast.success("Indents floated successfully");
          setsend_data([]);
          if (planningbutton) {
            document.getElementById("close_contact").click();
            // history.push("/indentrequest")
            if (update_orders) {
              res.data.loads.map((load) => {
                update_orders(load);
              });
            }
          }

          // Apply filter to update the indent list
          apply_Filter(true, 0, 10, (skipactive - 1) * 10 + 10, 0, "active");
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    }

    // Handle planning button specific actions
    if (planningbutton) {
      if (rspl.length > 0 && all_indent_list.length === 0) {
        var create_plan_indent_payload = {
          load_ids: temp.map((indent) => indent.load_id),
        };
        axios
          .put(
            `${Urls.edit_planning_loads}?field=plan_update&action=create_indent`,
            create_plan_indent_payload
          )
          .then((res) => {

            if (update_orders) {
              res.data.loads.map((load) => {
                update_orders(load);
              });
            }
          })
          .catch((e) => console.log(e));
      } else {
        var create_plan_indent_payload = {
          load_ids: temp.map((indent) => indent.load_id),
        };
        axios
          .put(
            `${Urls.edit_planning_loads}?field=plan_update&action=create_indent&multiple=true`,
            create_plan_indent_payload
          )
          .then((res) => {
            if (update_orders) {
              res.data.loads.map((load) => {
                update_orders(load);
              });
            }
          })
          .catch((e) => console.log(e));
      }
    }
  };

  /**
   * Handles the submission process by performing validation checks, tracking user activities,
   * and creating indents if all validations pass.
   * @returns {void}
   */
  const submitHandler = () => {
    // Log the activity of creating indents
    Activity([
      {
        screen: "Indents",
        module: "Indent Request",
        user_activity: `Create Indents`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    const tracking_data_string = send_data.map(item =>
      `Origin: ${item.origin.location.location}, ${item.origin.location.state} (location code : ${item.origin.location_code}) | Destination: ${item.destination.location.location}, ${item.destination.location.state} (location code : ${item.origin.location_code}) | Truck Type: ${item.truck_types.map(t => t.label).join(", ")} | Placement Date: ${item.placement_date}`
    ).join("; ");

    // Track the user action with Mixpanel
    trackIndentEvent("indent request", "user has clicked on create indent button", `${tracking_data_string}`)

    // Reference the data to be processed
    var temp = send_data;
    // var isShortlistEmpty = ''
    // var re = /^[-+]?[0-9]+\.[0-9]+$/;
    // Initialize flags for validation checks
    var list = [];
    var invalid = false;
    var invalid_date = false;
    var invalid_transporter = false;

    // Perform validation checks if `temp` has data
    if (temp && temp.length > 0) {
      temp.map((item) => {
        // Check if truck_required is invalid
        if (item.truck_required <= 0) {
          invalid = true;
        }
        // Check if placement_date is invalid
        else if (
          item.placement_date === null ||
          item.placement_date === undefined ||
          item.placement_date === ""
        ) {
          invalid_date = true;
        }
        // Check each shortlisted transporter
        item.shortlisted_transporters.map((data) => {
          if (data.transporter_id === undefined) {
            invalid_transporter = true;
          }
          // Add shortlisted transporter to the list
          if (data.is_shortlist === true) {
            list.push(data);
          }
          return data;
        });
        return item;
      });
    }

    // Display appropriate message based on validation results
    if (invalid_date) {
      toast.info("Please select date of placement");
    } else if (invalid) {
      toast.info("Truck required cannot be negative or zero or decimal");
    } else if (list.length > 0 && !invalid && !invalid_transporter) {
      // If all validations pass, show the loading indicator and create indents
      setshow(true);
      createIndent(temp);
      if (planningbutton) {
        let change_log_payload = {
          action: "Create Indent",
          screen: "planning",
          user_email: user_email,
          user_id: user_id,
          timestamp: currentRequestTimeStamp(),
          date: temp.dispatch_date,
          company_id: companyId,
          change_activity: change_activity(item),
          remarks: "",
        };
        MastersChangeLog(null, null, null, null, null, null, null, null, change_log_payload)
      }
    } else if (invalid_transporter) {
      toast.info("Please shortlist transporters");
    } else {
      toast.info("Please shortlist transporters");
    }
  };

  const [exceldownloadindents, setExceldownloadindents] = useState([]);

  /**
   * Renders an invisible HTML table used for exporting indent data to Excel.
   * The table includes columns for indent request details and related transporter information.
   * @returns {JSX.Element} The JSX element representing the invisible table.
   */
  const ExcelFileTable = () => {
    return (
      <table style={{ display: "none" }} id="indent_request_table">
        <thead style={{ background: "whitesmoke" }}>
          <tr>
            <th>Indent Request No</th>
            <th>User Name</th>
            <th>Created On</th>
            <th>Origin</th>
            <th>Destination</th>
            <th>Sales Invoice Number</th>
            <th>Truck type</th>
            <th># Truck Required</th>
            <th>Date of placement</th>
            <th>Transporter Name</th>
            <th>Initial Quote</th>
            <th>Final Quote</th>
            <th>Savings</th>
            <th>Status</th>
            <th>Allocated trucks</th>
            <th>Cancelled/ Expired</th>
          </tr>
        </thead>
        <tbody>
          {exceldownloadindents && exceldownloadindents.length > 0 ? (
            exceldownloadindents.map((indent, index) => {
              return indent.summary.map((transporter) => {
                return (
                  <tr key={transporter.transporter_id || index}>
                    <td>{indent.display_indent_id}</td>
                    <td>
                      {indent.user_list && indent.user_list.length > 0
                        ? indent.user_list.map((it) => {
                          return titleCase(it.user_email.split("@")[0]);
                        })
                        : null}
                    </td>
                    <td>{indent.created_date}</td>
                    <td>{indent.indent_info.origin.location_name}</td>
                    <td>{indent.indent_info.destination.location_name}</td>
                    <td>
                      {Array.isArray(indent.indent_info.truck_types)
                        ? indent.indent_info.truck_types.map((ttt) => ttt.value)
                        : indent.indent_info.truck_types.label}
                    </td>
                    <td>
                      {indent.document_details ? indent.document_details : "NA"}
                    </td>
                    <td>{indent.indent_info.truck_required}</td>
                    <td>{indent.indent_info.placement_date}</td>
                    <td>{transporter.transporter_name}</td>
                    {/* First Quote */}
                    <td>
                      {indent.indent_info.from &&
                        indent.indent_info.from === "adhoc"
                        ? indent.indent_info.shortlisted_transporters &&
                          indent.indent_info.shortlisted_transporters.length > 0
                          ? indent.indent_info.shortlisted_transporters.map(
                            (t) => {
                              if (
                                t.transporter_id ===
                                transporter.transporter_id
                              ) {
                                return t.rate_list && t.rate_list.length > 0
                                  ? t.rate_list[0].rate
                                  : t.rate
                                    ? t.rate
                                    : "-";
                              }
                            }
                          )
                          : "-"
                        : null}
                    </td>
                    {/* Final Quote */}
                    <td>
                      {indent.indent_info.shortlisted_transporters &&
                        indent.indent_info.shortlisted_transporters.length > 0
                        ? indent.indent_info.shortlisted_transporters[0].rate
                        : "-"}
                    </td>
                    {/* Savings */}
                    <td>
                      {indent.indent_info.from &&
                        indent.indent_info.from === "adhoc"
                        ? indent.indent_info.shortlisted_transporters &&
                          indent.indent_info.shortlisted_transporters.length > 0
                          ? indent.indent_info.shortlisted_transporters.map(
                            (t) => {
                              if (
                                t.transporter_id ===
                                transporter.transporter_id
                              ) {
                                return t.rate_list && t.rate_list.length > 0
                                  ? t.rate_list[0].rate -
                                  t.rate_list[t.rate_list.length - 1].rate
                                  : "-";
                              }
                            }
                          )
                          : "-"
                        : null}
                    </td>
                    <td>{transporter.indent_status}</td>
                    <td>
                      {transporter.allocation
                        ? transporter.allocation.allocated_truck
                        : "NA"}
                    </td>
                    <td>
                      {(indent.is_delete && indent.is_delete === true) ||
                        (indent.is_expired && indent.is_expired === true)
                        ? "yes"
                        : "no"}
                    </td>
                  </tr>
                );
              });
            })
          ) : (
            <tr>
              <td>No Results Found</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  /**
   * Closes the Modal by taking its ID
   * @returns {void}
   */
  const closeButtonModal1 = () => {
    document.getElementById("close_contact").click();
  };

  // const handleViewToggle = () => {
  //     setAutoView(!autoView)
  // }

  return (
    <>
      <Loader show={show} />
      {!planningbutton ? (
        <div style={{ width: "104%", marginLeft: "-14px" }}>
          {!isMobile() ? (
            // web for Upload indent button do not show in planning
            <>
              {!planningbutton ? (
                send_data.length > 0 ? null : (
                  <div
                    className="d-flex justify-content-end align-items-center"
                    style={{
                      width: "25%",
                      right: "0",
                      position: "absolute",
                      marginRight: "4%",
                      marginTop: "1.2%",
                    }}
                  >
                    <div className="mt-3">
                      <strong style={{ fontSize: "18px", marginRight: "29px" }}>
                        OR
                      </strong>
                      {/* <button className="btn btn-success" style={{marginRight:"-33px"}}>
                    Bulk Upload
                  </button> */}
                      <Modal
                        style={{ marginRight: "-33px" }}
                        closeButtonId="close_contactus1"
                        id="closebutton"
                        moduleName="Upload Indents"
                        dialogClassName={
                          step === 1 || !file || step === 4
                            ? classes.modalClassname
                            : classes.modalClassnameNew
                        }
                        screenName="Auction"
                        // buttonLabel={isConfigureModal === true ? "Header Configuration" : "Upload File"}
                        buttonLabel={"Upload Indents"}
                        // disabled={isDisabled}
                        title={`${step === 0
                          ? "Upload Indents"
                          : step === 2
                            ? "Check Uploaded Lanes"
                            : "Customise Selected Format"
                          }`}
                        header={`${step === 0
                          ? "Upload Indents"
                          : step === 2
                            ? "Check Uploaded Lanes"
                            : "Customise Selected Format"
                          }`}
                        overflowStyles={{ overflow: "auto" }}
                        content={
                          <BulkUploadFile
                            setFile={setFile}
                            finalKeys={finalKeys}
                            step={step}
                            file={file}
                            fileName={file?.name}
                            isUploading={show}
                            floatFromFM={floatFromFM}
                            setFloatFromFM={setFloatFromFM}
                            setFinalKeys={setFinalKeys}
                            setNewStep={setNewStep}
                            newStep={newStep}
                            setData={setData}
                            setTotalRequiredFields={setTotalRequiredFields}
                            setStep={setStep}
                            data={data}
                            setshow={setshow}
                          />
                        }
                        buttonClass={`btn btn-secondary h-100`}
                        onClose={() => {
                          setStep(0);
                          setNewStep(0);
                          setFile(null);
                          setData([]);
                          setFinalKeys({});
                          setFloatFromFM("yes");
                          if (newStep > 3) {
                            apply_Filter(true, 0, 10, 0, 0, "active");
                          }
                          // const excelID =
                          //   localStorage.getItem("fm_excel_id") || "";
                          // if (newStep > 1 && excelID !== "") {
                          //   next_page({
                          //     data: "completed",
                          //     excel_id: excelID,
                          //     key: "page",
                          //   });
                          // }
                          // setNewStep(1);
                        }}
                        size={step === 0 ? "md" : newStep === 4 ? "2xl" : "lg"}
                        disabled={isRestricted}
                      />
                    </div>
                    <div style={{ marginTop: "-49%", marginRight: "-31%" }}>
                      <Modal
                        style={{
                          fontSize: "13px",
                          margin: isMobile() ? "2% -5%" : "1.7%",
                        }}
                        buttonLabel={`Download Report`}
                        buttonClass="btn btn-sm btn-primary tr-button1"
                        content={
                          <DownloadIndentReports
                            days={15}
                            bucket={indentBucket}
                            level={indentLevel}
                            indent_type="indent"
                          />
                        }
                        title={`Report Generator`}
                        id="closebutton"
                        size={"lg"}
                        screenName="LoRRI Indent"
                        moduleName="Indent Request"
                        activityName={`Download Report`}
                        backdrop={false}
                        disabled={!canAccessReports}
                      />

                    </div>
                  </div>
                )
              ) : null}
              {!planningbutton ? (
                <AddIndent
                  origin={origin}
                  inputorigin={inputorigin}
                  setorigin={setorigin}
                  setinputorigin={setinputorigin}
                  destination={destination}
                  inputdestination={inputdestination}
                  setdestination={setdestination}
                  setinputdestination={setinputdestination}
                  TruckTypes={TruckTypes}
                  selectedTrucks={selectedTrucks}
                  todaydate={todaydate}
                  addLanetoProcurement={addLanetoProcurement}
                  onChangeTruckTypes={onChangeTruckTypes}
                  setduedate={setduedate}
                  truckrequired={truckrequired}
                  settruckrequired={settruckrequired}
                  setDopStartTime={setDopStartTime}
                  setDopEndTime={setDopEndTime}
                  dopStartTime={dopStartTime}
                  dopEndTime={dopEndTime}
                  isRestricted={isRestricted}
                />
              ) : null}
            </>
          ) : !planningbutton ? (
            <div style={{ display: "flow-root" }}>
              <AddIndent
                origin={origin}
                inputorigin={inputorigin}
                setorigin={setorigin}
                setinputorigin={setinputorigin}
                destination={destination}
                inputdestination={inputdestination}
                setdestination={setdestination}
                setinputdestination={setinputdestination}
                TruckTypes={TruckTypes}
                selectedTrucks={selectedTrucks}
                todaydate={todaydate}
                addLanetoProcurement={addLanetoProcurement}
                onChangeTruckTypes={onChangeTruckTypes}
                setduedate={setduedate}
                truckrequired={truckrequired}
                settruckrequired={settruckrequired}
                setDopStartTime={setDopStartTime}
                setDopEndTime={setDopEndTime}
                dopStartTime={dopStartTime}
                dopEndTime={dopEndTime}
                isRestricted={isRestricted}
              />
            </div>
          ) : null}
          <>
            {send_data.length > 0 ? (
              <>
                {!isMobile() ? (
                  // web for create indent
                  <div className="row">
                    <div
                      style={{ width: "96%" }}
                      className={` ${classes["t-div"]} ${classes1["table-div"]}`}
                    >
                      <table className={classes["table-s"]}>
                        <thead
                          style={{
                            textAlign: "center",
                            backgroundColor: "#f2f2f2",
                            lineHeight: "13px",
                          }}
                        >
                          {/* <thead style={{ position: "-webkit-sticky", position: "sticky", top: "0%", zIndex: "998", fontSize: "20px", backgroundColor: "white" }}> */}
                          <tr>
                            <th style={{ width: "2%", textAlign: "center" }}>
                              Sr. No.
                            </th>
                            <th style={{ width: "15%", textAlign: "center" }}>
                              Origin
                            </th>
                            <th style={{ width: "15%", textAlign: "center" }}>
                              Destination
                            </th>
                            {!planningbutton && (
                              <th style={{ width: "15%", textAlign: "center" }}>
                                Sales Invoice Number
                              </th>
                            )}
                            {/* {!planningbutton && <th style={{ width: "15%", textAlign: "center" }}>Sales Number</th>} */}
                            <th style={{ width: "14%", textAlign: "center" }}>
                              Truck Type
                            </th>
                            <th style={{ width: "8%", textAlign: "center" }}>
                              # Truck Required
                            </th>
                            <th style={{ width: "10%", textAlign: "center" }}>
                              Date of Placement
                            </th>
                            <th style={{ width: "8%", textAlign: "center" }}>
                              Start Time
                            </th>
                            <th style={{ width: "8%", textAlign: "center" }}>
                              End Time
                            </th>
                            <th className={classes["s-tn"]}>
                              Shortlist Transporters
                            </th>
                            <th className={classes["s-tn"]}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {send_data && send_data.length > 0
                            ? send_data.map((item, index) => (
                              <tr
                                key={index}
                                style={{
                                  borderBottom: "1px solid lightgrey",
                                }}
                              >
                                <td
                                  style={{
                                    width: "2%",
                                    textAlign: "center",
                                  }}
                                >
                                  {index + 1}
                                </td>
                                <td
                                  style={{
                                    width: "11%",
                                    textAlign: "left",
                                  }}
                                >
                                  {item.origin.location_name}
                                </td>
                                <td
                                  style={{
                                    width: "15%",
                                    textAlign: "left",
                                  }}
                                >
                                  {item.destination.location_name}
                                </td>
                                <input
                                  type="text"
                                  style={{
                                    fontSize: "13px",
                                    height: "28px",
                                    width: "88%",
                                    marginLeft: "8%",
                                    marginTop: "7%",
                                    padding: "15px",
                                  }}
                                  defaultValue={
                                    item.document_details
                                      ? item.document_details
                                      : ""
                                  }
                                  onInput={(event) =>
                                    onChangeDoc(
                                      event.target.value,
                                      item,
                                      index
                                    )
                                  }
                                />
                                <td
                                  style={{
                                    width: "18%",
                                    textAlign: "center",
                                  }}
                                >
                                  {/* <Select
                                                      options={TruckTypes}
                                                      isMulti={false}
                                                      onChange={value => onChangeTruckTypessenddata(value, item)}
                                                      value={item.truck_types}
                                                      className={`Truck_Type_Select truckMargin`}
                                                      classNamePrefix={"Truck_Prefix"}
                                                      defaultValue=""
                                                      isDisabled={true}
                                                  /> */}
                                  {item.truck_types[0].value}
                                </td>
                                <td
                                  style={{
                                    width: "10%",
                                    textAlign: "center",
                                  }}
                                >
                                  <input
                                    type="number"
                                    min="1"
                                    style={{
                                      fontSize: "13px",
                                      height: "28px",
                                      width: "88%",
                                      marginLeft: "8%",
                                      marginTop: "7%",
                                      padding: "15px",
                                    }}
                                    defaultValue={
                                      item.truck_required
                                        ? item.truck_required
                                        : ""
                                    }
                                    onInput={(event) =>
                                      onInputChange(
                                        event.target.value,
                                        item,
                                        index
                                      )
                                    }
                                  />
                                </td>
                                <td
                                  style={{
                                    width: "8%",
                                    textAlign: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "13px",
                                      width: "90%",
                                      marginLeft: "5%",
                                      marginTop: "-3%",
                                    }}
                                  >
                                    <input
                                      style={{ padding: "16px" }}
                                      type="date"
                                      defaultValue={item.placement_date}
                                      min={todaydate}
                                      onChange={(e) =>
                                        onEditDate(
                                          e.target.value,
                                          item,
                                          index
                                        )
                                      }
                                    ></input>
                                  </div>
                                </td>
                                <td style={{ width: "8%", textAlign: "center" }}>
                                  <div
                                    style={{
                                      fontSize: "13px",
                                      width: "90%",
                                      marginLeft: "5%",
                                      marginTop: "-3%",
                                    }}
                                  >
                                    <input
                                      style={{ padding: "16px" }}
                                      type="time"
                                      defaultValue={item.dop_start_time || ""}
                                      onChange={(e) => onEditStartTime(e.target.value, item, index)}
                                    />
                                  </div>
                                </td>

                                {/* END TIME */}
                                <td style={{ width: "8%", textAlign: "center" }}>
                                  <div
                                    style={{
                                      fontSize: "13px",
                                      width: "90%",
                                      marginLeft: "5%",
                                      marginTop: "-3%",
                                    }}
                                  >
                                    <input
                                      style={{ padding: "16px" }}
                                      type="time"
                                      defaultValue={item.dop_end_time || ""}
                                      onChange={(e) => onEditEndTime(e.target.value, item, index)}
                                    />
                                  </div>
                                </td>

                                <td
                                  style={{
                                    width: "4%",
                                    textAlign: "center",
                                  }}
                                >
                                  <Modal
                                    buttonLabel={
                                      <span style={{ fontSize: "13px" }}>
                                        View Transporters
                                      </span>
                                    }
                                    buttonClass="btn btn-link"
                                    content={<ViewLsp
                                      item={item}
                                      planningbutton={planningbutton}
                                      setshow={setshow}
                                      autoAllocation={autoView}
                                    />}
                                    title={`Shortlist Transporters`}
                                    subtitle="(This Indent will be sent to the selected transporters)"
                                    size="md"
                                    id="closebutton"
                                    screenName="Indent"
                                    moduleName="Indent Request"
                                    activityName={`View LSP button clicked for ${item.origin
                                      ? item.origin.location_name
                                      : "NA"
                                      } to ${item.destination
                                        ? item.destination.location_name
                                        : "NA"
                                      }`}
                                    backdrop={true}
                                    closeButtonId="close_contactus"
                                    style={{ fontSize: "13px" }}
                                  />
                                </td>
                                <td style={{ fontSize: "13px", width: "6%" }}>
                                  <button
                                    style={{ marginLeft: "2%" }}
                                    className="btn btn-sm btn-primary"
                                    onClick={(e) =>
                                      deleteHandler(e, item, index)
                                    }
                                  >
                                    <i
                                      className="fa fa-trash"
                                      style={{ color: "white" }}
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                            : null}
                        </tbody>
                      </table>
                    </div>
                    <button
                      onClick={(e) => submitHandler(e)}
                      className={`btn btn-success ${classes1["submit-button"]}`}
                      disabled={isRestricted || noIndentaccess}
                    >
                      Submit
                    </button>
                  </div>
                ) : send_data && send_data.length > 0 ? (
                  send_data.map((item, index) => (
                    // mobile for create indent
                    <div className={classes1["mobile-enquiry"]}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          paddingBottom: "5%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "16px",
                            display: "flex",
                            justifyContent: "flex-end",
                            fontWeight: "600",
                            width: "125px",
                          }}
                        >
                          <i
                            className="fa fa-map-marker"
                            style={{
                              color: "#393186",
                              marginRight: "6%",
                              marginTop: "2%",
                            }}
                          />
                          <span
                            style={{ cursor: "pointer" }}
                            data-tip
                            data-for={`origin${index}`}
                          >
                            {item.origin && item.origin.location_name
                              ? item.origin.location_name
                              : "NA"}
                          </span>
                          <ReactTooltip
                            id={`origin${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="float"
                            backgroundColor="#393185 !important"
                          >
                            {item.origin.location_name}
                          </ReactTooltip>
                        </div>
                        <i
                          className={`fa fa-arrow-right`}
                          style={{ marginTop: "1%" }}
                        />
                        <div
                          style={{
                            fontSize: "16px",
                            display: "flex",
                            width: "125px",
                            fontWeight: "600",
                          }}
                        >
                          <i
                            className="fa fa-map-marker"
                            style={{
                              color: "#393186",
                              marginRight: "6%",
                              marginTop: "2%",
                            }}
                          />
                          <span
                            style={{ cursor: "pointer" }}
                            data-tip
                            data-for={`destination${index}`}
                          >
                            {item.destination && item.destination.location_name
                              ? item.destination.location_name
                              : "NA"}
                          </span>
                          <ReactTooltip
                            id={`destination${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="float"
                            backgroundColor="#393185 !important"
                          >
                            {item.destination.location_name}
                          </ReactTooltip>
                        </div>
                      </div>
                      <div style={{ fontSize: "14px", textAlign: "left" }}>
                        <div style={{ display: "flex" }}>
                          <span style={{ marginTop: "1%" }}>Truck Type : </span>
                          <span style={{ marginLeft: "27%", width: "50%" }}>
                            <Select
                              options={TruckTypes}
                              isMulti={false}
                              onChange={(value) =>
                                onChangeTruckTypessenddata(value, item)
                              }
                              value={item?.truck_types ? item.truck_types : ""}
                              className={"Truck_Type_Select"}
                              classNamePrefix={"Truck_Prefix"}
                              defaultValue=""
                              isDisabled={true}
                              styles={{
                                groupHeading: (provided) => ({
                                  ...provided,
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  textTransform: "none",
                                  marginLeft: "10px",
                                }),
                              }}
                              formatOptionLabel={({ label, isMyTruck }) => (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  {isMyTruck && (
                                    <i
                                      className="fa fa-truck"
                                      style={{ marginRight: "8px", color: "#393185", fontSize: "14px" }}
                                    ></i>
                                  )}
                                  <div>{label}</div>
                                </div>
                              )}
                            />
                          </span>
                        </div>
                      </div>
                      <div style={{ fontSize: "14px", textAlign: "left" }}>
                        <div style={{ display: "flex" }}>
                          <span style={{ marginTop: "1%" }}>
                            # Trucks Required :{" "}
                          </span>
                          <input
                            type="number"
                            min="1"
                            style={{
                              fontSize: "13px",
                              height: "28px",
                              width: "21%",
                              marginTop: "1%",
                              marginLeft: "15%",
                            }}
                            defaultValue={
                              item.truck_required ? item.truck_required : ""
                            }
                            onInput={(event) =>
                              onInputChange(event.target.value, item, index)
                            }
                          />
                        </div>
                        <div style={{ display: "flex" }}>
                          <span style={{ marginTop: "1%" }}>
                            # Date of Placements :{" "}
                          </span>
                          <div
                            style={{
                              fontSize: "13px",
                              width: "50%",
                              marginLeft: "8%",
                            }}
                          >
                            <input
                              type="date"
                              defaultValue={item.placement_date}
                              min={todaydate}
                              onChange={(e) =>
                                onEditDate(e.target.value, item, index)
                              }
                            ></input>
                          </div>
                        </div>
                        <div style={{ display: "flex", paddingTop: "2%" }}>
                          <span style={{ marginTop: "1%" }}>
                            Shortlist Transporters :{" "}
                          </span>
                          <Modal
                            buttonLabel={
                              <span style={{ fontSize: "13px" }}>
                                View Transporters
                              </span>
                            }
                            buttonClass="btn btn-link"
                            content={<ViewLsp item={item}
                              planningbutton={planningbutton}
                              setshow={setshow}
                              autoAllocation={autoView}
                            />}
                            title={`Shortlist Transporters`}
                            subtitle="(This Indent will be sent to the selected transporters)"
                            id="closebutton"
                            size="md"
                            screenName="Indent"
                            moduleName="Indent Request"
                            activityName={`View LSP button clicked for ${item.origin ? item.origin.location_name : "NA"
                              } to ${item.destination
                                ? item.destination.location_name
                                : "NA"
                              }`}
                            backdrop={true}
                            closeButtonId="close_contactus"
                            style={{ fontSize: "13px" }}
                          />
                        </div>
                        <div>
                          <button
                            style={{ marginLeft: "2%" }}
                            className="btn btn-sm btn-primary"
                            onClick={(e) => deleteHandler(e, item, index)}
                          >
                            <i
                              className="fa fa-trash"
                              style={{ color: "white" }}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : null}
              </>
            ) : (
              <>
                {!isMobile() ? (
                  <div className="row">
                    {!planningbutton ? <ExcelFileTable /> : null}
                    <div
                      className="d-flex justify-content-between align-items-center mb-2 px-3"
                      style={{
                        margin: "1% 0%",
                        width: "100%",
                      }}
                    >
                      <div className={`d-flex align-items-center ${classes1.gap15}`}>
                        <div className="filter-button-container">
                          {!planningbutton ? (
                            <button
                              className={`btn btn-sm btn-primary tr-button1 ${classes1.filterBtn} ${classes1.ml21}`}
                              onClick={() => setShowNewFilter(true)}
                            >
                              <i className="fas fa-filter" style={{ color: "white" }}></i>
                              Filter {getFilterCount() > 0 ? `(${getFilterCount()})` : ""}
                            </button>
                          ) : null}
                        </div>
                      </div>

                      <div className={`d-flex justify-content-end align-items-center ${classes1.gap10}`}>
                        {!planningbutton ? (
                          <div className={`d-flex flex-row align-items-center ${classes1.gap10}`}>
                            <select
                              className={`form-control ${classes1.viewSelect}`}
                              value={indentBucket}
                              onChange={(e) => {
                                const newBucket = e.target.value;
                                setIndentBucket(newBucket);
                                setIsFilterActive(true);
                                const updatedPayload = {
                                  ...(filterPayload || {
                                    filters: [],
                                    search: "",
                                    sort: { key: "created_date", order: "desc" },
                                    pagination: { skip: 0, limit: 10 }
                                  }),
                                  bucket: newBucket,
                                  view: indentLevel
                                };
                                setFilterPayload(updatedPayload);
                                apply_Filter(true, 0, 10, 0, 0, newBucket, updatedPayload, indentLevel);
                              }}
                            >
                              <option value="active">Active Indents</option>
                              <option value="pending">Pending Indents</option>
                              <option value="expired">Expired Indents</option>
                              <option value="cancelled">Cancelled Indents</option>
                              <option value="accepted">Accepted Indents</option>
                              <option value="rejected">Rejected Indents</option>
                            </select>

                            {allowed_view_indent && (
                              <select
                                className={`form-control ${classes1.viewSelect}`}
                                value={indentLevel}
                                onChange={(e) => {
                                  const newLevel = e.target.value;
                                  setIndentLevel(newLevel);
                                  setuserview(newLevel === "company_view" ? false : true);
                                  setIsFilterActive(true);
                                  const updatedPayload = {
                                    ...(filterPayload || {
                                      filters: [],
                                      search: "",
                                      sort: { key: "created_date", order: "desc" },
                                      pagination: { skip: 0, limit: 10 }
                                    }),
                                    view: newLevel,
                                    bucket: indentBucket
                                  };
                                  setFilterPayload(updatedPayload);
                                  apply_Filter(true, 0, 10, 0, 0, indentBucket, updatedPayload, newLevel);
                                }}
                              >
                                <option value="user_view">My Indents</option>
                                <option value="company_view">Company Indents</option>
                              </select>
                            )}

                            <button
                              className={`btn btn-sm btn-outline-primary ${classes1.refreshButton}`}
                              onClick={() => {
                                apply_Filter(true, 0, 10, 0, 0, indentBucket, null, indentLevel);
                              }}
                              title="Refresh Data"
                            >
                              <i className="fas fa-sync-alt" />
                            </button>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {renderActiveFilters()}
                    {!planningbutton ? <AddedLanes /> : null}
                  </div>
                ) : (
                  <div className="row m-0">
                    {!planningbutton ? (
                      <>
                        <div className={classes1["mobile-filter-bar"]}>
                          {/* Filter button - icon only on mobile to save space */}
                          <button
                            className={`btn btn-sm btn-primary ${classes1.filterBtn}`}
                            onClick={() => setShowNewFilter(true)}
                            style={{ flexShrink: 0, flexGrow: 0, width: '36px', padding: '0', justifyContent: 'center' }}
                            title="Filter"
                          >
                            <i className="fas fa-filter" style={{ color: "white" }} />
                            {getFilterCount() > 0 ? <span style={{ fontSize: '10px', marginLeft: '2px' }}>{getFilterCount()}</span> : ""}
                          </button>

                          {/* Bucket select */}
                          <Select
                            options={[
                              { label: "Active Indents", value: "active" },
                              { label: "Pending Indents", value: "pending" },
                              { label: "Expired Indents", value: "expired" },
                              { label: "Cancelled Indents", value: "cancelled" },
                              {label: "Accepted Indents", value: "accepted"},
                              {label: "Rejected Indents", value: "rejected"},
                            ]}
                            onChange={(e) => {
                              Activity([
                                {
                                  screen: "Indents",
                                  module: "Indent Request",
                                  user_activity: `${e.label} Indents Radio Button Clicked`,
                                  timestamp: currentRequestTimeStamp(),
                                },
                              ]);

                              trackIndentEvent("indent request", "User has clicked indent type", `${e.label} selected`)

                              setIsFilterActive(true);
                              const updatedPayload = {
                                ...(filterPayload || {
                                  filters: [],
                                  search: "",
                                  sort: { key: "created_date", order: "desc" },
                                  pagination: { skip: 0, limit: 10 }
                                }),
                                bucket: e.value,
                                view: indentLevel
                              };
                              setFilterPayload(updatedPayload);
                              apply_Filter(true, 0, 10, 0, 0, e.value, updatedPayload, indentLevel);
                              setIndentBucket(e.value);
                            }}
                            isSearchable={false}
                            isMulti={false}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            className={`Truck_Type_Select ${classes1["options-select"]}`}
                            classNamePrefix={"Truck_Prefix"}
                            value={
                              cancelledindents
                                ? { label: "Cancelled Indents", value: "cancelled" }
                                : expiredIndents
                                  ? { label: "Expired Indents", value: "expired" }
                                  : pendingIndents
                                    ? { label: "Pending Indents", value: "pending" }
                                    : acceptedIndents
                                    ? { label: "Accepted Indents", value: "accepted" }
                                    : rejectedIndents
                                    ? { label: "Rejected Indents", value: "rejected" }
                                    :{ label: "Active Indents", value: "active" }
                            }
                          />

                          {/* View select (My/Company Indents) */}
                          {allowed_view_indent ? (
                            <Select
                              options={[
                                { label: "My Indents", value: "user_view" },
                                {
                                  label: "Company Indents",
                                  value: "company_view",
                                },
                              ]}
                              onChange={(e) => {
                                Activity([
                                  {
                                    screen: "LoRRI Indent",
                                    module: "LoRRI Indent",
                                    user_activity: `${e.label} selected`,
                                    timestamp: currentRequestTimeStamp(),
                                  },
                                ]);

                                trackIndentEvent("indent request", `${e.label} selected`, `user has clicked on indent category (my/company indent) tab`, `filterd by: ${e.label}`)

                                setIsFilterActive(true);
                                const updatedPayload = {
                                  ...(filterPayload || {
                                    filters: [],
                                    search: "",
                                    sort: { key: "created_date", order: "desc" },
                                    pagination: { skip: 0, limit: 10 }
                                  }),
                                  view: e.value,
                                  bucket: indentBucket
                                };
                                setFilterPayload(updatedPayload);
                                apply_Filter(true, 0, 10, 0, 0, indentBucket, updatedPayload, e.value);
                                setuserview(
                                  e.value === "company_view" ? false : true
                                );
                                setIndentLevel(e.value);
                              }}
                              isSearchable={false}
                              isMulti={false}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                              className={`Truck_Type_Select ${classes1["options-select1"]}`}
                              classNamePrefix={"Truck_Prefix"}
                              value={
                                userview
                                  ? {
                                    label: "My Indents",
                                    value: "user_view",
                                  }
                                  : {
                                    label: "Company Indents",
                                    value: "company_view",
                                  }
                              }
                            />
                          ) : null}

                          {/* Refresh button */}
                          <button
                            className={`btn btn-sm btn-outline-primary ${classes1.refreshButton}`}
                            onClick={() => {
                              apply_Filter(true, 0, 10, 0, 0, indentBucket, null, indentLevel);
                            }}
                            title="Refresh"
                            style={{ flexShrink: 0 }}
                          >
                            <i className="fas fa-sync-alt" />
                          </button>
                        </div>
                        {renderActiveFilters()}
                        {!planningbutton ? <AddedLanes /> : null}
                        <ExcelFileTable />
                      </>
                    ) : null}
                  </div>
                )}
              </>
            )}
          </>
        </div>
      ) : (
        // TODO: add logic as above (non planning indent creation flow in below planning code)
        <div>
          <Loader show={show} />
          <div className="row">
            <div
              style={{ width: "96%" }}
              className={` ${classes["t-div"]} ${classes1["table-div"]}`}
            >
              <table className={classes["table-s"]}>
                <thead
                  style={{
                    textAlign: "center",
                    backgroundColor: "#f2f2f2",
                    lineHeight: "13px",
                  }}
                >
                  {/* <thead style={{ position: "-webkit-sticky", position: "sticky", top: "0%", zIndex: "998", fontSize: "20px", backgroundColor: "white" }}> */}
                  <tr>
                    <th style={{ width: "6%", textAlign: "center" }}>
                      Sr. No.
                    </th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Origin
                    </th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Destination
                    </th>
                    {/* {!planningbutton && <th style={{ width: "15%", textAlign: "center" }}>Sales Number</th>} */}
                    {!planningbutton && (
                      <th style={{ width: "15%", textAlign: "center" }}>
                        Sales Invoice Number
                      </th>
                    )}
                    {/* <th style={{ width: "15%", textAlign: "center" }}>Document ID</th> */}
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Truck Type
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      # Truck Required
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Date of Placement
                    </th>
                    <th style={{ width: "17%", textAlign: "center" }}>
                      Shortlist Transporters
                    </th>
                    {planningbutton ? (
                      <th style={{ width: "15%", textAlign: "center" }}>
                        Assign POC
                      </th>
                    ) : null}
                    <th style={{ width: "8%", textAlign: "center" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {send_data && send_data.length > 0
                    ? send_data.map((item, index) => (
                      <tr
                        key={index}
                        style={{ borderBottom: "1px solid lightgrey" }}
                      >
                        <td style={{ width: "5%", textAlign: "center" }}>
                          {index + 1}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            textAlign: "center",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          data-tip
                          data-for={`origin${index}`}
                        >
                          {/* {item.origin && item.origin.location_name? item.origin.location_name: ""} */}
                          <i
                            className="fa fa-map-marker"
                            style={{ color: "#393186", marginRight: "4%" }}
                          />
                          {item?.origin &&
                            item?.origin?.location_name &&
                            item?.origin?.location?.location?.split(",")[0]
                            ? item?.origin?.location_name?.split(",")[0]
                            : item?.origin?.location?.location ? item?.origin?.location?.location : ""}
                          <ReactTooltip
                            id={`origin${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="float"
                            backgroundColor="#393185 !important"
                          >
                            {item?.origin && item?.origin?.location_name
                              ? item?.origin?.location_name
                              : item?.origin?.location?.label ? item?.origin?.location?.label : ""}
                          </ReactTooltip>
                        </td>
                        <td
                          style={{
                            width: "15%",
                            textAlign: "left",
                            paddingLeft: "2%",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          data-tip
                          data-for={`destination${index}`}
                        >
                          {/* {item.destination && item.destination.location_name? item.destination.location_name:""} */}
                          <i
                            className="fa fa-map-marker"
                            style={{ color: "#393186", marginRight: "4%" }}
                          />
                          {item?.destination &&
                            item?.destination?.location_name &&
                            item?.destination?.location?.location?.split(",")[0]
                            ? item?.destination?.location_name?.split(",")[0]
                            : item?.destination?.location?.location ? item.destination?.location?.location : ""}
                          <ReactTooltip
                            id={`destination${index}`}
                            className={`${classes["tooltip"]}`}
                            place="bottom"
                            effect="float"
                            backgroundColor="#393185 !important"
                          >
                            {item?.destination &&
                              item?.destination?.location_name
                              ? item?.destination?.location_name
                              : item?.destination?.location?.label ? item?.destination?.location?.label : ""}
                          </ReactTooltip>
                        </td>
                        <td
                          style={{
                            width: "15%",
                            textAlign: "center",
                            paddingTop: "1%",
                          }}
                        >
                          <Select
                            options={TruckTypes}
                            isMulti={false}
                            onChange={(value) =>
                              onChangeTruckTypessenddata(value, item)
                            }
                            value={item?.truck_types ? item.truck_types : ""}
                            className={`Truck_Type_Select truckMargin`}
                            classNamePrefix={"Truck_Prefix"}
                            defaultValue=""
                            isDisabled={true}
                          />
                        </td>
                        <td style={{ width: "10%", textAlign: "center" }}>
                          <input
                            type="number"
                            min="1"
                            style={{
                              fontSize: "13px",
                              height: "28px",
                              width: "56%",
                              marginLeft: "25%",
                              marginTop: "7%",
                              padding: "15px",
                            }}
                            defaultValue={
                              item.truck_required ? item.truck_required : ""
                            }
                            onInput={(event) =>
                              onInputChange(event.target.value, item, index)
                            }
                            disabled={planningbutton}
                          />
                        </td>
                        <td style={{ width: "10%", textAlign: "center" }}>
                          <div
                            style={{
                              fontSize: "13px",
                              width: "90%",
                              marginLeft: "5%",
                              marginTop: "-3%",
                            }}
                          >
                            <input
                              style={{ padding: "16px" }}
                              type="date"
                              defaultValue={
                                item.placement_date || item.dispatch_date
                              }
                              min={todaydate}
                              onChange={(e) =>
                                onEditDate(e.target.value, item, index)
                              }
                            ></input>
                          </div>
                        </td>

                        <td style={{ width: "17%", textAlign: "center" }}>
                          <Modal
                            buttonLabel={
                              <span style={{ fontSize: "13px" }}>
                                View Transporters
                              </span>
                            }
                            buttonClass="btn btn-link"
                            content={<ViewLsp item={item}
                              planningbutton={planningbutton}
                              setshow={setshow}
                              autoAllocation={autoView}
                            />}
                            title={`Shortlist Transporters`}
                            subtitle={`(This Indent will be sent to the selected transporters)`}
                            id="closebutton"
                            screenName="Indent"
                            moduleName="Indent Request"
                            size="md"
                            activityName={`View LSP button clicked for ${item.origin ? item.origin.location_name : "NA"
                              } to ${item.destination
                                ? item.destination.location_name
                                : "NA"
                              }`}
                            backdrop={true}
                            closeButtonId="close_contactus"
                            style={{ fontSize: "13px" }}
                          />
                        </td>

                        <td style={{ width: "15%", textAlign: "center" }}>
                          {planningbutton ? (
                            <>
                              <select
                                className={`form-control`}
                                onChange={(e) =>
                                  handleSelectChange(e, item.truck_id)
                                }
                              >
                                {/* <option disabled selected>Select User</option> */}
                                {useroption && useroption.length > 0
                                  ? useroption.map((option) => {
                                    return (
                                      <>
                                        <option
                                          key={option.email}
                                          value={option.email}
                                          selected={
                                            item.email === option.email
                                          }
                                        >
                                          {option.email
                                            ? option.email.split("@")[0]
                                            : ""}
                                        </option>
                                      </>
                                    );
                                  })
                                  : null}
                              </select>
                            </>
                          ) : null}
                        </td>
                        <td style={{ fontSize: "13px", width: "8%" }}>
                          <button
                            style={{ marginLeft: "2%" }}
                            className="btn btn-sm btn-primary"
                            onClick={(e) => deleteHandler(e, item, index)}
                          >
                            <i
                              className="fa fa-trash"
                              style={{ color: "white" }}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))
                    : null}
                </tbody>
              </table>
            </div>
            <div
              style={{ display: "flex", marginTop: "2%", marginLeft: "44%" }}
            >
              <center style={{ display: "contents" }}>
                <button
                  className="btn btn-sm btn-primary"
                  style={{
                    marginRight: "10%",
                    marginLeft: "35%",
                    height: "90%",
                    marginTop: "2%",
                    marginBottom: isMobile() ? "2%" : "",
                  }}
                  onClick={() => closeButtonModal1()}
                >
                  Back
                </button>
                <button
                  onClick={(e) => submitHandler(e)}
                  className={`btn btn-success ${!planningbutton
                    ? classes1["submit-button"]
                    : classes1["planning-submit-button"]
                    }`}
                  disabled={isRestricted || noIndentaccess}
                >
                  Submit
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
      {showNewFilter && (
        <MultiSelectFilterUI
          filterBaseUrl={Urls.indent}
          module="indent_request"
          action="filterable_fields"
          filterField="filters"
          onFilterApply={handleFilterApply}
          onReset={handleFilterReset}
          isOpen={showNewFilter}
          onClose={() => setShowNewFilter(false)}
          initialPayload={filterPayload}
          defaultSortOptions={DEFAULT_SORT_OPTIONS}
          showViewSelection={allowed_view_indent}
          isLoading={show}
          extraPayload={{
            view: userview ? "user_view" : "company_view",
            company_id: companyId,
            bucket: indentBucket
          }}
        />
      )}
    </>
  );
};

export default Indent;
